var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _polygon, _path319, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMigrationCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2086 1448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:#bdd0fb;}.cls-8{fill:#18174a;}.cls-9{fill:#2b69b3;}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:#fff;}.cls-12{opacity:0.7;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#linear-gradient-15);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{fill:url(#linear-gradient-17);}.cls-24{fill:url(#linear-gradient-18);}.cls-25{fill:url(#linear-gradient-19);}.cls-26{fill:url(#linear-gradient-20);}.cls-27{fill:#7d97f4;}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}.cls-52{fill:url(#linear-gradient-45);}.cls-53{fill:url(#linear-gradient-46);}.cls-54{fill:url(#linear-gradient-47);}.cls-55{fill:url(#linear-gradient-48);}.cls-56{fill:url(#linear-gradient-49);}.cls-57{fill:url(#linear-gradient-50);}.cls-58{fill:url(#linear-gradient-51);}.cls-59{fill:url(#linear-gradient-52);}.cls-60{fill:url(#linear-gradient-53);}.cls-61{fill:url(#linear-gradient-54);}.cls-62{fill:url(#linear-gradient-55);}.cls-63{fill:url(#linear-gradient-56);}.cls-64{fill:url(#linear-gradient-57);}.cls-65{fill:url(#linear-gradient-58);}.cls-66{fill:url(#linear-gradient-59);}.cls-67{fill:url(#linear-gradient-60);}.cls-68{fill:url(#linear-gradient-61);}.cls-69{fill:url(#linear-gradient-62);}.cls-70{fill:url(#linear-gradient-63);}.cls-71{fill:url(#linear-gradient-64);}.cls-72{fill:url(#linear-gradient-65);}.cls-73{fill:url(#linear-gradient-66);}.cls-74{fill:url(#linear-gradient-67);}.cls-75{fill:url(#linear-gradient-68);}.cls-76{fill:url(#linear-gradient-69);}.cls-77{fill:url(#linear-gradient-70);}.cls-78{fill:url(#linear-gradient-71);}.cls-79{fill:url(#linear-gradient-72);}.cls-80{fill:url(#linear-gradient-73);}.cls-81{fill:url(#linear-gradient-74);}.cls-82{fill:url(#linear-gradient-75);}.cls-83{fill:url(#linear-gradient-76);}.cls-84{fill:url(#linear-gradient-77);}.cls-85{fill:url(#linear-gradient-78);}.cls-86{fill:url(#linear-gradient-79);}.cls-87{fill:url(#linear-gradient-80);}.cls-88{fill:url(#linear-gradient-81);}.cls-89{fill:url(#linear-gradient-82);}.cls-90{fill:url(#linear-gradient-83);}.cls-91{fill:url(#linear-gradient-84);}.cls-92{fill:url(#linear-gradient-85);}.cls-93{fill:url(#linear-gradient-86);}.cls-94{fill:url(#linear-gradient-87);}.cls-95{fill:url(#linear-gradient-88);}.cls-96{fill:url(#linear-gradient-89);}.cls-97{fill:url(#linear-gradient-90);}.cls-98{fill:url(#linear-gradient-91);}.cls-99{fill:url(#linear-gradient-92);}.cls-100{fill:url(#linear-gradient-93);}.cls-101{fill:url(#linear-gradient-94);}.cls-102{fill:url(#linear-gradient-95);}.cls-103{fill:url(#linear-gradient-96);}.cls-104{fill:url(#linear-gradient-97);}.cls-105{fill:url(#linear-gradient-98);}.cls-106{fill:url(#linear-gradient-99);}.cls-107{fill:url(#linear-gradient-100);}.cls-108{fill:url(#linear-gradient-101);}.cls-109{fill:url(#linear-gradient-102);}.cls-110{fill:url(#linear-gradient-103);}.cls-111{fill:url(#linear-gradient-104);}.cls-112{fill:url(#linear-gradient-105);}.cls-113{fill:url(#linear-gradient-106);}.cls-114{fill:url(#linear-gradient-107);}.cls-115{fill:url(#linear-gradient-108);}.cls-116{fill:url(#linear-gradient-109);}.cls-117{fill:url(#linear-gradient-110);}.cls-118{fill:url(#linear-gradient-111);}.cls-119{fill:url(#linear-gradient-112);}.cls-120{fill:url(#linear-gradient-113);}.cls-121{fill:url(#linear-gradient-114);}.cls-122{fill:url(#linear-gradient-115);}.cls-123{fill:url(#linear-gradient-116);}.cls-124{fill:url(#linear-gradient-117);}.cls-125{fill:url(#linear-gradient-118);}.cls-126{fill:url(#linear-gradient-119);}.cls-127{fill:url(#linear-gradient-120);}.cls-128{fill:url(#linear-gradient-121);}.cls-129{fill:url(#linear-gradient-122);}.cls-130{fill:url(#linear-gradient-123);}.cls-131{fill:url(#linear-gradient-124);}.cls-132{fill:url(#linear-gradient-125);}.cls-133{fill:url(#linear-gradient-126);}.cls-134{fill:url(#linear-gradient-127);}.cls-135{fill:url(#linear-gradient-128);}.cls-136{fill:url(#linear-gradient-129);}.cls-137{fill:url(#linear-gradient-130);}.cls-138{fill:url(#linear-gradient-131);}.cls-139{fill:url(#linear-gradient-132);}.cls-140{fill:url(#linear-gradient-133);}.cls-141{fill:url(#linear-gradient-134);}.cls-142{fill:url(#linear-gradient-135);}.cls-143{fill:url(#linear-gradient-136);}.cls-144{fill:url(#linear-gradient-137);}.cls-145{fill:url(#linear-gradient-138);}.cls-146{fill:url(#linear-gradient-139);}.cls-147{fill:url(#linear-gradient-140);}.cls-148{fill:url(#linear-gradient-141);}.cls-149{fill:url(#linear-gradient-142);}.cls-150{fill:url(#linear-gradient-143);}.cls-151{fill:url(#linear-gradient-144);}.cls-152{fill:url(#linear-gradient-145);}.cls-153{fill:url(#linear-gradient-146);}.cls-154{fill:url(#linear-gradient-147);}.cls-155{fill:url(#linear-gradient-148);}.cls-156{fill:url(#linear-gradient-149);}.cls-157{fill:url(#linear-gradient-150);}.cls-158{fill:url(#linear-gradient-151);}.cls-159{fill:url(#linear-gradient-152);}.cls-160{fill:url(#linear-gradient-153);}.cls-161{fill:url(#linear-gradient-154);}.cls-162{fill:url(#linear-gradient-155);}.cls-163{fill:url(#linear-gradient-156);}.cls-164{fill:url(#linear-gradient-157);}.cls-165{fill:url(#linear-gradient-158);}.cls-166{fill:url(#linear-gradient-159);}.cls-167{fill:url(#linear-gradient-160);}.cls-168{fill:url(#linear-gradient-161);}.cls-169{fill:url(#linear-gradient-162);}.cls-170{fill:url(#linear-gradient-163);}.cls-171{fill:url(#linear-gradient-164);}.cls-172{fill:url(#linear-gradient-165);}.cls-173{fill:url(#linear-gradient-166);}.cls-174{fill:url(#linear-gradient-167);}.cls-175{fill:url(#linear-gradient-168);}.cls-176{fill:url(#linear-gradient-169);}.cls-177{fill:url(#linear-gradient-170);}.cls-178{fill:url(#linear-gradient-171);}.cls-179{fill:url(#linear-gradient-172);}.cls-180{fill:url(#linear-gradient-173);}.cls-181{fill:url(#linear-gradient-174);}.cls-182{fill:url(#linear-gradient-175);}.cls-183{fill:url(#linear-gradient-176);}.cls-184{fill:url(#linear-gradient-177);}.cls-185{fill:url(#linear-gradient-178);}.cls-186{fill:url(#linear-gradient-179);}.cls-187{fill:url(#linear-gradient-180);}.cls-188{fill:url(#linear-gradient-181);}.cls-189{fill:url(#linear-gradient-182);}.cls-190{fill:url(#linear-gradient-183);}.cls-191{fill:url(#linear-gradient-184);}.cls-192{fill:url(#linear-gradient-185);}.cls-193{fill:url(#linear-gradient-186);}.cls-194{fill:url(#linear-gradient-187);}.cls-195{fill:url(#linear-gradient-188);}.cls-196{fill:url(#linear-gradient-189);}.cls-197{fill:url(#linear-gradient-190);}.cls-198{fill:url(#linear-gradient-191);}.cls-199{fill:url(#linear-gradient-192);}.cls-200{fill:url(#linear-gradient-193);}.cls-201{fill:url(#linear-gradient-194);}.cls-202{fill:url(#linear-gradient-195);}.cls-203{fill:url(#linear-gradient-196);}.cls-204{fill:url(#linear-gradient-197);}.cls-205{fill:url(#linear-gradient-198);}.cls-206{fill:url(#linear-gradient-199);}.cls-207{fill:url(#linear-gradient-200);}.cls-208{fill:url(#linear-gradient-201);}.cls-209{fill:url(#linear-gradient-202);}.cls-210{fill:url(#linear-gradient-203);}.cls-211{fill:url(#linear-gradient-204);}.cls-212{fill:url(#linear-gradient-205);}.cls-213{fill:url(#linear-gradient-206);}.cls-214{fill:url(#linear-gradient-207);}.cls-215{fill:url(#linear-gradient-208);}.cls-216{fill:url(#linear-gradient-209);}.cls-217{fill:url(#linear-gradient-210);}.cls-218{fill:url(#linear-gradient-211);}.cls-219{fill:url(#linear-gradient-212);}.cls-220{fill:url(#linear-gradient-213);}.cls-221{fill:url(#linear-gradient-214);}.cls-222{fill:url(#linear-gradient-215);}.cls-223{fill:url(#linear-gradient-216);}.cls-224{fill:url(#linear-gradient-217);}.cls-225{fill:url(#linear-gradient-218);}.cls-226{fill:url(#linear-gradient-219);}.cls-227{fill:url(#linear-gradient-220);}.cls-228{fill:url(#linear-gradient-221);}.cls-229{fill:url(#linear-gradient-222);}.cls-230{fill:url(#linear-gradient-223);}.cls-231{fill:url(#linear-gradient-224);}.cls-232{fill:url(#linear-gradient-225);}.cls-233{fill:url(#linear-gradient-226);}.cls-234{fill:url(#linear-gradient-227);}.cls-235{fill:url(#linear-gradient-228);}.cls-236{fill:url(#linear-gradient-229);}.cls-237{fill:url(#linear-gradient-230);}.cls-238{fill:url(#linear-gradient-231);}.cls-239{fill:url(#linear-gradient-232);}.cls-240{fill:url(#linear-gradient-233);}.cls-241{fill:url(#linear-gradient-234);}.cls-242{fill:url(#linear-gradient-235);}.cls-243{fill:url(#linear-gradient-236);}.cls-244{fill:url(#linear-gradient-237);}.cls-245{fill:url(#linear-gradient-238);}.cls-246{fill:url(#linear-gradient-239);}.cls-247{fill:url(#linear-gradient-240);}.cls-248{fill:url(#linear-gradient-241);}.cls-249{fill:url(#linear-gradient-242);}.cls-250{fill:url(#linear-gradient-243);}.cls-251{fill:url(#linear-gradient-244);}.cls-252{fill:url(#linear-gradient-245);}.cls-253{fill:url(#linear-gradient-246);}.cls-254{fill:url(#linear-gradient-247);}.cls-255{fill:url(#linear-gradient-248);}.cls-256{fill:url(#linear-gradient-249);}.cls-257{fill:url(#linear-gradient-250);}.cls-258{fill:url(#linear-gradient-251);}.cls-259{fill:url(#linear-gradient-252);}.cls-260{fill:url(#linear-gradient-253);}.cls-261{fill:url(#linear-gradient-254);}.cls-262{fill:url(#linear-gradient-255);}.cls-263{fill:url(#linear-gradient-256);}.cls-264{fill:url(#linear-gradient-257);}.cls-265{fill:url(#linear-gradient-258);}.cls-266{fill:url(#linear-gradient-259);}.cls-267{fill:url(#linear-gradient-260);}.cls-268{fill:url(#linear-gradient-261);}.cls-269{fill:url(#linear-gradient-262);}.cls-270{fill:url(#linear-gradient-263);}.cls-271{fill:url(#linear-gradient-264);}.cls-272{fill:url(#linear-gradient-265);}.cls-273{fill:url(#linear-gradient-266);}.cls-274{fill:url(#linear-gradient-267);}.cls-275{fill:url(#linear-gradient-268);}.cls-276{fill:url(#linear-gradient-269);}.cls-277{fill:url(#linear-gradient-270);}.cls-278{fill:url(#linear-gradient-271);}.cls-279{fill:url(#linear-gradient-272);}.cls-280{fill:url(#linear-gradient-273);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7946.21,
    y1: 2276.4,
    x2: -6061.66,
    y2: 2276.4,
    gradientTransform: "translate(-5973.74 3046.95) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1313.96,
    y1: 267.37,
    x2: 1389.53,
    y2: 267.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1249.99,
    y1: 267.6,
    x2: 1451.82,
    y2: 267.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 961.09,
    y1: 311.02,
    x2: 1004.31,
    y2: 311.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 925.26,
    y1: 311.21,
    x2: 1039.24,
    y2: 311.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3244.56,
    y1: -48.85,
    x2: 119.47,
    y2: 1263.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1749.89,
    y1: 1112.13,
    x2: 1517.34,
    y2: 1202.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ab6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f68e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 517.49,
    y1: 688.81,
    x2: 460.49,
    y2: 794.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2904.57,
    y1: 11067.77,
    x2: -2927.24,
    y2: 11133.77,
    gradientTransform: "translate(-123.21)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2824.96,
    y1: 11095.1,
    x2: -2847.62,
    y2: 11161.1,
    gradientTransform: "translate(-123.21)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 373.5,
    y1: 839.47,
    x2: 411.54,
    y2: 730.24,
    gradientTransform: "translate(-123.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 651.29,
    y1: 646.05,
    x2: 583.29,
    y2: 739.05,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 516.18,
    y1: 594.71,
    x2: 297.16,
    y2: 990.75,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 367.11,
    y1: 829.85,
    x2: 316.11,
    y2: 920.85,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 370.56,
    y1: 685.08,
    x2: 269.56,
    y2: 837.08,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 411.22,
    y1: 652.85,
    x2: 370.22,
    y2: 686.85,
    gradientTransform: "matrix(1, 0, 0, 1, 1.24, 3.22)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 367.28,
    y1: 663.12,
    x2: 285.28,
    y2: 738.12,
    gradientTransform: "matrix(1, 0, 0, 1, 1.24, 3.22)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 459.75,
    y1: 718.52,
    x2: 429.08,
    y2: 794.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 609.67,
    y1: 615.62,
    x2: 541.67,
    y2: 708.62,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -19.2,
    y1: 1239.7,
    x2: 30.79,
    y2: 1291.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 1399.41, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 47.11,
    y1: 1370.74,
    x2: 141.66,
    y2: 1440.13,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1558.51,
    y1: 1038.74,
    x2: 1517.51,
    y2: 1175.74,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1695.77,
    y1: 1006.84,
    x2: 1521.77,
    y2: 1358.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1658.23,
    y1: 955.25,
    x2: 1652.23,
    y2: 1104.25,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 583.4,
    y1: -885.83,
    x2: 556.4,
    y2: -824.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 1399.41, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 560.4,
    y1: -896,
    x2: 533.4,
    y2: -835,
    gradientTransform: "matrix(-1, 0, 0, 1, 1399.41, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1595.44,
    y1: 1086.07,
    x2: 1604.28,
    y2: 1086.07,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1647.14,
    y1: 1100.95,
    x2: 1664.52,
    y2: 1100.95,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1681.77,
    y1: 1128.6,
    x2: 1722.88,
    y2: 1128.6,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1457.49,
    y1: 1086.22,
    x2: 1513.13,
    y2: 1086.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1642.15,
    y1: 1057.98,
    x2: 1598.15,
    y2: 1141.98,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1484.63,
    y1: 1074.04,
    x2: 1487.21,
    y2: 1074.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1488.45,
    y1: 1064.76,
    x2: 1490.84,
    y2: 1064.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1491.56,
    y1: 1055.23,
    x2: 1493.73,
    y2: 1055.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1493.87,
    y1: 1045.47,
    x2: 1495.79,
    y2: 1045.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1495.28,
    y1: 1035.56,
    x2: 1496.92,
    y2: 1035.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1495.61,
    y1: 1025.57,
    x2: 1497.11,
    y2: 1025.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1494.62,
    y1: 1015.61,
    x2: 1496.47,
    y2: 1015.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1492.53,
    y1: 1005.8,
    x2: 1494.73,
    y2: 1005.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1489.36,
    y1: 996.27,
    x2: 1491.89,
    y2: 996.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1485.16,
    y1: 987.13,
    x2: 1488.01,
    y2: 987.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1480.03,
    y1: 978.47,
    x2: 1483.16,
    y2: 978.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1474.07,
    y1: 970.35,
    x2: 1477.45,
    y2: 970.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1467.4,
    y1: 962.82,
    x2: 1471,
    y2: 962.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1460.13,
    y1: 955.87,
    x2: 1463.9,
    y2: 955.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1452.34,
    y1: 949.5,
    x2: 1456.27,
    y2: 949.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1444.12,
    y1: 943.71,
    x2: 1448.19,
    y2: 943.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1435.55,
    y1: 938.48,
    x2: 1439.73,
    y2: 938.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1426.68,
    y1: 933.77,
    x2: 1430.95,
    y2: 933.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1417.56,
    y1: 929.57,
    x2: 1421.92,
    y2: 929.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1408.24,
    y1: 925.87,
    x2: 1412.67,
    y2: 925.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1398.75,
    y1: 922.62,
    x2: 1403.24,
    y2: 922.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1389.13,
    y1: 919.84,
    x2: 1393.67,
    y2: 919.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1379.39,
    y1: 917.48,
    x2: 1383.97,
    y2: 917.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1369.56,
    y1: 915.55,
    x2: 1374.18,
    y2: 915.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1359.66,
    y1: 914.02,
    x2: 1364.31,
    y2: 914.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1349.71,
    y1: 912.9,
    x2: 1354.39,
    y2: 912.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1339.73,
    y1: 912.16,
    x2: 1344.43,
    y2: 912.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1329.73,
    y1: 911.81,
    x2: 1334.44,
    y2: 911.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1319.72,
    y1: 911.84,
    x2: 1324.45,
    y2: 911.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1309.73,
    y1: 912.23,
    x2: 1314.47,
    y2: 912.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1299.76,
    y1: 913,
    x2: 1304.5,
    y2: 913,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1289.82,
    y1: 914.1,
    x2: 1294.56,
    y2: 914.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1279.91,
    y1: 915.41,
    x2: 1284.65,
    y2: 915.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1270.02,
    y1: 916.93,
    x2: 1274.76,
    y2: 916.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1260.17,
    y1: 918.63,
    x2: 1264.91,
    y2: 918.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1250.35,
    y1: 920.52,
    x2: 1255.09,
    y2: 920.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1240.56,
    y1: 922.58,
    x2: 1245.31,
    y2: 922.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1230.82,
    y1: 924.82,
    x2: 1235.56,
    y2: 924.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1221.11,
    y1: 927.23,
    x2: 1225.85,
    y2: 927.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1211.45,
    y1: 929.8,
    x2: 1216.19,
    y2: 929.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1201.83,
    y1: 932.53,
    x2: 1206.57,
    y2: 932.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1192.26,
    y1: 935.41,
    x2: 1196.99,
    y2: 935.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1182.73,
    y1: 938.43,
    x2: 1187.46,
    y2: 938.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1173.24,
    y1: 941.59,
    x2: 1177.97,
    y2: 941.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1163.8,
    y1: 944.88,
    x2: 1168.53,
    y2: 944.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1154.41,
    y1: 948.29,
    x2: 1159.13,
    y2: 948.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1145.05,
    y1: 951.83,
    x2: 1149.77,
    y2: 951.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1135.75,
    y1: 955.49,
    x2: 1140.46,
    y2: 955.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1126.48,
    y1: 959.25,
    x2: 1131.2,
    y2: 959.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1117.26,
    y1: 963.11,
    x2: 1121.97,
    y2: 963.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1108.08,
    y1: 967.08,
    x2: 1112.79,
    y2: 967.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1098.94,
    y1: 971.14,
    x2: 1103.65,
    y2: 971.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1089.84,
    y1: 975.28,
    x2: 1094.55,
    y2: 975.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1080.78,
    y1: 979.51,
    x2: 1085.49,
    y2: 979.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1071.76,
    y1: 983.81,
    x2: 1076.46,
    y2: 983.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1062.76,
    y1: 988.19,
    x2: 1067.47,
    y2: 988.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1053.81,
    y1: 992.64,
    x2: 1058.51,
    y2: 992.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1044.88,
    y1: 997.15,
    x2: 1049.59,
    y2: 997.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1035.98,
    y1: 1001.71,
    x2: 1040.69,
    y2: 1001.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1027.11,
    y1: 1006.33,
    x2: 1031.83,
    y2: 1006.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1018.27,
    y1: 1011.01,
    x2: 1022.99,
    y2: 1011.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1009.45,
    y1: 1015.72,
    x2: 1014.17,
    y2: 1015.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1000.65,
    y1: 1020.48,
    x2: 1005.38,
    y2: 1020.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 991.87,
    y1: 1025.27,
    x2: 996.6,
    y2: 1025.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 983.11,
    y1: 1030.1,
    x2: 987.85,
    y2: 1030.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 974.37,
    y1: 1034.95,
    x2: 979.11,
    y2: 1034.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 965.63,
    y1: 1039.83,
    x2: 970.38,
    y2: 1039.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 956.91,
    y1: 1044.73,
    x2: 961.67,
    y2: 1044.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 948.2,
    y1: 1049.64,
    x2: 952.96,
    y2: 1049.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 939.49,
    y1: 1054.56,
    x2: 944.26,
    y2: 1054.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 930.78,
    y1: 1059.49,
    x2: 935.56,
    y2: 1059.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 922.07,
    y1: 1064.41,
    x2: 926.86,
    y2: 1064.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 913.35,
    y1: 1069.33,
    x2: 918.16,
    y2: 1069.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 904.63,
    y1: 1074.23,
    x2: 909.45,
    y2: 1074.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 895.9,
    y1: 1079.12,
    x2: 900.74,
    y2: 1079.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 887.16,
    y1: 1083.99,
    x2: 892.01,
    y2: 1083.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 878.41,
    y1: 1088.84,
    x2: 883.27,
    y2: 1088.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 869.64,
    y1: 1093.66,
    x2: 874.52,
    y2: 1093.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 860.85,
    y1: 1098.45,
    x2: 865.75,
    y2: 1098.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 852.04,
    y1: 1103.2,
    x2: 856.96,
    y2: 1103.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 843.21,
    y1: 1107.91,
    x2: 848.15,
    y2: 1107.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 834.36,
    y1: 1112.58,
    x2: 839.31,
    y2: 1112.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 825.48,
    y1: 1117.19,
    x2: 830.45,
    y2: 1117.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 816.57,
    y1: 1121.75,
    x2: 821.56,
    y2: 1121.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 807.63,
    y1: 1126.25,
    x2: 812.64,
    y2: 1126.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 798.65,
    y1: 1130.69,
    x2: 803.68,
    y2: 1130.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 789.65,
    y1: 1135.05,
    x2: 794.7,
    y2: 1135.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 780.6,
    y1: 1139.34,
    x2: 785.68,
    y2: 1139.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 771.52,
    y1: 1143.55,
    x2: 776.62,
    y2: 1143.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 762.4,
    y1: 1147.68,
    x2: 767.52,
    y2: 1147.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 753.24,
    y1: 1151.72,
    x2: 758.38,
    y2: 1151.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 744.04,
    y1: 1155.66,
    x2: 749.2,
    y2: 1155.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 734.79,
    y1: 1159.5,
    x2: 739.98,
    y2: 1159.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 725.5,
    y1: 1163.23,
    x2: 730.72,
    y2: 1163.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 716.17,
    y1: 1166.85,
    x2: 721.41,
    y2: 1166.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 706.79,
    y1: 1170.35,
    x2: 712.05,
    y2: 1170.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 697.37,
    y1: 1173.73,
    x2: 702.65,
    y2: 1173.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 687.9,
    y1: 1176.98,
    x2: 693.21,
    y2: 1176.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 678.39,
    y1: 1180.1,
    x2: 683.72,
    y2: 1180.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 668.83,
    y1: 1183.08,
    x2: 674.19,
    y2: 1183.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 659.22,
    y1: 1185.91,
    x2: 664.61,
    y2: 1185.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 649.58,
    y1: 1188.58,
    x2: 654.98,
    y2: 1188.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 639.89,
    y1: 1191.1,
    x2: 645.32,
    y2: 1191.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 630.16,
    y1: 1193.46,
    x2: 635.61,
    y2: 1193.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 620.39,
    y1: 1195.65,
    x2: 625.87,
    y2: 1195.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 610.58,
    y1: 1197.67,
    x2: 616.08,
    y2: 1197.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 600.74,
    y1: 1199.48,
    x2: 606.26,
    y2: 1199.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 590.86,
    y1: 1201.08,
    x2: 596.4,
    y2: 1201.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 580.94,
    y1: 1202.47,
    x2: 586.51,
    y2: 1202.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 571.01,
    y1: 1203.65,
    x2: 576.59,
    y2: 1203.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 561.04,
    y1: 1204.61,
    x2: 566.64,
    y2: 1204.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 551.06,
    y1: 1205.36,
    x2: 556.68,
    y2: 1205.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 541.07,
    y1: 1205.89,
    x2: 546.7,
    y2: 1205.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 531.07,
    y1: 1206.2,
    x2: 536.71,
    y2: 1206.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 521.06,
    y1: 1206.3,
    x2: 526.72,
    y2: 1206.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 511.06,
    y1: 1206.17,
    x2: 516.72,
    y2: 1206.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 501.06,
    y1: 1205.82,
    x2: 506.73,
    y2: 1205.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 491.08,
    y1: 1205.23,
    x2: 496.75,
    y2: 1205.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 481.11,
    y1: 1204.42,
    x2: 486.79,
    y2: 1204.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 471.16,
    y1: 1203.37,
    x2: 476.85,
    y2: 1203.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 461.24,
    y1: 1202.09,
    x2: 466.93,
    y2: 1202.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 451.36,
    y1: 1200.55,
    x2: 457.05,
    y2: 1200.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 441.52,
    y1: 1198.78,
    x2: 447.21,
    y2: 1198.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 431.73,
    y1: 1196.75,
    x2: 437.41,
    y2: 1196.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 422,
    y1: 1194.46,
    x2: 427.67,
    y2: 1194.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 412.33,
    y1: 1191.92,
    x2: 418,
    y2: 1191.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 402.74,
    y1: 1189.11,
    x2: 408.39,
    y2: 1189.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 393.24,
    y1: 1186.03,
    x2: 398.87,
    y2: 1186.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 383.83,
    y1: 1182.68,
    x2: 389.44,
    y2: 1182.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 374.52,
    y1: 1179.05,
    x2: 380.11,
    y2: 1179.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 365.33,
    y1: 1175.14,
    x2: 370.9,
    y2: 1175.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 356.27,
    y1: 1170.94,
    x2: 361.81,
    y2: 1170.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 347.34,
    y1: 1166.46,
    x2: 352.85,
    y2: 1166.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 338.58,
    y1: 1161.69,
    x2: 344.05,
    y2: 1161.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 329.97,
    y1: 1156.62,
    x2: 335.4,
    y2: 1156.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 321.55,
    y1: 1151.27,
    x2: 326.94,
    y2: 1151.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 313.33,
    y1: 1145.62,
    x2: 318.66,
    y2: 1145.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 305.31,
    y1: 1139.68,
    x2: 310.59,
    y2: 1139.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 297.51,
    y1: 1133.45,
    x2: 302.74,
    y2: 1133.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 289.95,
    y1: 1126.94,
    x2: 295.12,
    y2: 1126.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 282.64,
    y1: 1120.16,
    x2: 287.74,
    y2: 1120.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 275.59,
    y1: 1113.1,
    x2: 280.62,
    y2: 1113.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 268.82,
    y1: 1105.78,
    x2: 273.77,
    y2: 1105.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 262.33,
    y1: 1098.21,
    x2: 267.21,
    y2: 1098.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 256.12,
    y1: 1090.4,
    x2: 260.92,
    y2: 1090.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 250.2,
    y1: 1082.37,
    x2: 254.93,
    y2: 1082.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 244.57,
    y1: 1074.13,
    x2: 249.22,
    y2: 1074.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 239.23,
    y1: 1065.7,
    x2: 243.8,
    y2: 1065.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 234.18,
    y1: 1057.09,
    x2: 238.68,
    y2: 1057.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 229.42,
    y1: 1048.32,
    x2: 233.84,
    y2: 1048.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 224.95,
    y1: 1039.4,
    x2: 229.29,
    y2: 1039.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 220.75,
    y1: 1030.34,
    x2: 225.02,
    y2: 1030.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 216.83,
    y1: 1021.15,
    x2: 221.03,
    y2: 1021.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 213.19,
    y1: 1011.86,
    x2: 217.32,
    y2: 1011.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 209.81,
    y1: 1002.46,
    x2: 213.87,
    y2: 1002.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 206.7,
    y1: 992.96,
    x2: 210.69,
    y2: 992.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 203.85,
    y1: 983.39,
    x2: 207.77,
    y2: 983.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 201.25,
    y1: 973.74,
    x2: 205.11,
    y2: 973.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 198.9,
    y1: 964.03,
    x2: 202.7,
    y2: 964.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 196.8,
    y1: 954.26,
    x2: 200.53,
    y2: 954.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 194.93,
    y1: 944.44,
    x2: 198.6,
    y2: 944.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 193.3,
    y1: 934.58,
    x2: 196.91,
    y2: 934.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 191.9,
    y1: 924.69,
    x2: 195.45,
    y2: 924.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 190.73,
    y1: 914.76,
    x2: 194.22,
    y2: 914.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 189.78,
    y1: 904.81,
    x2: 193.22,
    y2: 904.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 189.05,
    y1: 894.83,
    x2: 192.43,
    y2: 894.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 188.54,
    y1: 884.85,
    x2: 191.87,
    y2: 884.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 188.24,
    y1: 874.85,
    x2: 191.52,
    y2: 874.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 188.15,
    y1: 864.85,
    x2: 191.38,
    y2: 864.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 188.21,
    y1: 854.85,
    x2: 191.5,
    y2: 854.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 188.46,
    y1: 844.86,
    x2: 191.82,
    y2: 844.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 188.92,
    y1: 834.87,
    x2: 192.34,
    y2: 834.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 189.57,
    y1: 824.9,
    x2: 193.07,
    y2: 824.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 190.42,
    y1: 814.94,
    x2: 193.99,
    y2: 814.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 191.47,
    y1: 805,
    x2: 195.11,
    y2: 805,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 192.71,
    y1: 795.08,
    x2: 196.42,
    y2: 795.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 194.15,
    y1: 785.19,
    x2: 197.93,
    y2: 785.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 195.79,
    y1: 775.33,
    x2: 199.64,
    y2: 775.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 197.61,
    y1: 765.51,
    x2: 201.53,
    y2: 765.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 199.63,
    y1: 755.72,
    x2: 203.61,
    y2: 755.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 201.83,
    y1: 745.97,
    x2: 205.89,
    y2: 745.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 204.23,
    y1: 736.27,
    x2: 208.35,
    y2: 736.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 206.81,
    y1: 726.62,
    x2: 210.99,
    y2: 726.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 209.57,
    y1: 717.02,
    x2: 213.83,
    y2: 717.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 212.53,
    y1: 707.47,
    x2: 216.84,
    y2: 707.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 215.66,
    y1: 697.99,
    x2: 220.04,
    y2: 697.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 218.98,
    y1: 688.56,
    x2: 223.43,
    y2: 688.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 222.47,
    y1: 679.21,
    x2: 226.99,
    y2: 679.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 226.15,
    y1: 669.92,
    x2: 230.73,
    y2: 669.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 230,
    y1: 660.7,
    x2: 234.65,
    y2: 660.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 234.04,
    y1: 651.57,
    x2: 238.74,
    y2: 651.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 238.24,
    y1: 642.51,
    x2: 243.01,
    y2: 642.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 242.63,
    y1: 633.53,
    x2: 247.46,
    y2: 633.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 247.18,
    y1: 624.65,
    x2: 252.08,
    y2: 624.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 251.91,
    y1: 615.85,
    x2: 256.87,
    y2: 615.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 256.81,
    y1: 607.15,
    x2: 261.83,
    y2: 607.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 261.88,
    y1: 598.55,
    x2: 266.96,
    y2: 598.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 267.12,
    y1: 590.05,
    x2: 272.26,
    y2: 590.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 272.52,
    y1: 581.66,
    x2: 277.72,
    y2: 581.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 278.09,
    y1: 573.37,
    x2: 283.35,
    y2: 573.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 283.82,
    y1: 565.2,
    x2: 289.15,
    y2: 565.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 289.72,
    y1: 557.15,
    x2: 295.1,
    y2: 557.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 295.78,
    y1: 549.22,
    x2: 301.22,
    y2: 549.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 302,
    y1: 541.41,
    x2: 307.5,
    y2: 541.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 308.37,
    y1: 533.73,
    x2: 313.93,
    y2: 533.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 314.9,
    y1: 526.19,
    x2: 320.52,
    y2: 526.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 321.59,
    y1: 518.77,
    x2: 327.26,
    y2: 518.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 328.42,
    y1: 511.5,
    x2: 334.15,
    y2: 511.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 335.4,
    y1: 504.37,
    x2: 341.18,
    y2: 504.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 342.52,
    y1: 497.37,
    x2: 348.36,
    y2: 497.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 349.78,
    y1: 490.52,
    x2: 355.67,
    y2: 490.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 357.18,
    y1: 483.82,
    x2: 363.11,
    y2: 483.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 364.7,
    y1: 477.26,
    x2: 370.69,
    y2: 477.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 372.36,
    y1: 470.86,
    x2: 378.39,
    y2: 470.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 380.13,
    y1: 464.6,
    x2: 386.21,
    y2: 464.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 388.03,
    y1: 458.5,
    x2: 394.16,
    y2: 458.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 396.05,
    y1: 452.56,
    x2: 402.22,
    y2: 452.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 404.18,
    y1: 446.77,
    x2: 410.4,
    y2: 446.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 412.42,
    y1: 441.14,
    x2: 418.68,
    y2: 441.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 420.77,
    y1: 435.66,
    x2: 427.08,
    y2: 435.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 429.23,
    y1: 430.36,
    x2: 435.57,
    y2: 430.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 437.78,
    y1: 425.21,
    x2: 444.17,
    y2: 425.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 446.44,
    y1: 420.23,
    x2: 452.86,
    y2: 420.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 455.19,
    y1: 415.42,
    x2: 461.65,
    y2: 415.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 464.03,
    y1: 410.78,
    x2: 470.53,
    y2: 410.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 472.95,
    y1: 406.31,
    x2: 479.49,
    y2: 406.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 481.97,
    y1: 402.02,
    x2: 488.54,
    y2: 402.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 491.06,
    y1: 397.89,
    x2: 497.67,
    y2: 397.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 500.23,
    y1: 393.95,
    x2: 506.88,
    y2: 393.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 509.48,
    y1: 390.18,
    x2: 516.16,
    y2: 390.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 518.8,
    y1: 386.6,
    x2: 525.51,
    y2: 386.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 528.19,
    y1: 383.19,
    x2: 534.93,
    y2: 383.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 537.64,
    y1: 379.97,
    x2: 544.41,
    y2: 379.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 547.16,
    y1: 376.94,
    x2: 553.95,
    y2: 376.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 556.73,
    y1: 374.09,
    x2: 563.55,
    y2: 374.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 566.36,
    y1: 371.44,
    x2: 573.2,
    y2: 371.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 576.03,
    y1: 368.97,
    x2: 582.91,
    y2: 368.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 585.76,
    y1: 366.7,
    x2: 592.66,
    y2: 366.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 595.53,
    y1: 364.63,
    x2: 602.45,
    y2: 364.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 605.34,
    y1: 362.75,
    x2: 612.28,
    y2: 362.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 615.19,
    y1: 361.07,
    x2: 622.15,
    y2: 361.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 625.07,
    y1: 359.74,
    x2: 630.03,
    y2: 359.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1865.62,1189c91.3-81.81,167.33-225.71,37.73-362.48s-162.18-210.09-83.23-302.35S1928.9,250,1739.75,172.87s-274.63,294.69-419.87,258.55-183.45-303.17-433.33-279.7S683.41,457.37,521,390.58,183.84,252,116.82,401.6,268.45,666.15,269.17,847.07s-153.42,6.18-180,242.06C61,1339.11,507.66,1469.23,699,1340.31s328.91-337.16,461.87-282S1505.11,1512.07,1865.62,1189Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1584.73,312.16l-.19,0a1,1,0,0,1-.79-1.18c.26-1.3.5-2.6.73-3.91a1,1,0,0,1,2,.35c-.23,1.32-.48,2.63-.74,4A1,1,0,0,1,1584.73,312.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1352.48,503.17c-2.26,0-4.55,0-6.81-.1a1,1,0,1,1,0-2c2.24.06,4.52.1,6.76.1h1.13a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm14-.42a1,1,0,0,1-1-.94,1,1,0,0,1,.94-1.06c2.61-.15,5.26-.35,7.86-.59a1,1,0,0,1,1.09.9,1,1,0,0,1-.9,1.09c-2.63.24-5.3.44-7.93.6Zm-33.62-.4h-.08c-2.64-.22-5.3-.48-7.92-.79a1,1,0,0,1,.24-2c2.59.31,5.23.57,7.84.79a1,1,0,0,1-.08,2Zm54.28-1.73a1,1,0,0,1-1-.86,1,1,0,0,1,.84-1.13c2.59-.39,5.21-.82,7.78-1.29a1,1,0,0,1,.35,2c-2.59.47-5.23.91-7.84,1.3Zm-74.89-.92h-.17c-2.6-.45-5.23-.95-7.81-1.49a1,1,0,1,1,.4-2c2.57.53,5.17,1,7.75,1.48a1,1,0,0,1-.17,2Zm95.3-3a1,1,0,0,1-.23-2c2.55-.61,5.12-1.27,7.64-2a1,1,0,0,1,.52,1.93c-2.54.7-5.13,1.36-7.7,2A.91.91,0,0,1,1407.54,496.68ZM1292,495.25a.75.75,0,0,1-.26,0c-2.55-.68-5.13-1.41-7.65-2.17a1,1,0,1,1,.58-1.92c2.5.76,5.05,1.49,7.58,2.16a1,1,0,0,1-.25,2ZM1427.52,491a1,1,0,0,1-.31-2c2.48-.83,5-1.71,7.44-2.62a1,1,0,0,1,.69,1.88c-2.47.91-5,1.8-7.5,2.64A1.19,1.19,0,0,1,1427.52,491Zm-155.4-2a1.06,1.06,0,0,1-.34-.06c-2.48-.9-5-1.86-7.42-2.84a1,1,0,0,1,.74-1.86c2.43,1,4.9,1.93,7.37,2.82a1,1,0,0,1-.35,1.94Zm174.81-5.46a1,1,0,0,1-.91-.6,1,1,0,0,1,.52-1.32c2.4-1,4.82-2.13,7.18-3.25a1,1,0,0,1,.86,1.8c-2.39,1.13-4.83,2.24-7.25,3.29A.92.92,0,0,1,1446.93,483.55Zm-194-2.49a.92.92,0,0,1-.42-.1c-2.39-1.12-4.8-2.29-7.15-3.48a1,1,0,1,1,.91-1.79c2.33,1.19,4.71,2.35,7.09,3.46a1,1,0,0,1-.43,1.91Zm212.69-6.61a1,1,0,0,1-.47-1.88c2.3-1.25,4.61-2.55,6.87-3.88a1,1,0,1,1,1,1.73c-2.28,1.34-4.61,2.65-6.93,3.91A1,1,0,0,1,1465.62,474.45Zm-231.11-3a1,1,0,0,1-.5-.13l-1.45-.84c-1.8-1.06-3.61-2.16-5.38-3.25a1,1,0,1,1,1.06-1.7c1.75,1.09,3.55,2.17,5.34,3.22l1.43.84a1,1,0,0,1-.5,1.86Zm248.94-7.71a1,1,0,0,1-.84-.44,1,1,0,0,1,.28-1.39c2.18-1.44,4.37-3,6.51-4.47a1,1,0,0,1,1.39.23,1,1,0,0,1-.23,1.4c-2.16,1.53-4.37,3.05-6.56,4.51A1,1,0,0,1,1483.45,463.74ZM1217,460.28a.92.92,0,0,1-.57-.18c-2.16-1.51-4.33-3.08-6.44-4.67a1,1,0,1,1,1.2-1.59c2.09,1.57,4.24,3.12,6.39,4.62a1,1,0,0,1-.58,1.82Zm283.28-8.78a1,1,0,0,1-.62-1.78c2-1.64,4.09-3.33,6.09-5a1,1,0,1,1,1.3,1.52c-2,1.72-4.08,3.42-6.14,5.07A1,1,0,0,1,1500.25,451.5Zm-299.77-3.87a1,1,0,0,1-.64-.23c-2-1.7-4-3.46-6-5.22a1,1,0,0,1,1.34-1.49c1.95,1.75,3.95,3.49,5.95,5.17a1,1,0,0,1-.64,1.77Zm315.44-9.81a1,1,0,0,1-.73-.31,1,1,0,0,1,0-1.42c1.89-1.81,3.78-3.68,5.62-5.55a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42c-1.85,1.89-3.76,3.77-5.67,5.6A1,1,0,0,1,1515.92,437.82Zm-330.75-4.25a1,1,0,0,1-.71-.29c-1.86-1.86-3.71-3.79-5.52-5.73a1,1,0,1,1,1.46-1.36c1.79,1.92,3.63,3.83,5.48,5.68a1,1,0,0,1,0,1.41A1,1,0,0,1,1185.17,433.57Zm345.14-10.78a1,1,0,0,1-.66-.25,1,1,0,0,1-.09-1.41c1.72-2,3.43-4,5.1-6a1,1,0,0,1,1.54,1.26c-1.67,2.05-3.4,4.09-5.14,6.07A1,1,0,0,1,1530.31,422.79Zm-359.15-4.57a1,1,0,0,1-.77-.36c-1.68-2-3.36-4.1-5-6.19a1,1,0,1,1,1.58-1.23c1.62,2.08,3.28,4.14,5,6.14a1,1,0,0,1-.13,1.41A1,1,0,0,1,1171.16,418.22Zm372.14-11.64a1,1,0,0,1-.59-.2,1,1,0,0,1-.21-1.39c1.54-2.12,3.08-4.28,4.55-6.44a1,1,0,0,1,1.39-.27,1,1,0,0,1,.26,1.39c-1.48,2.18-3,4.37-4.59,6.5A1,1,0,0,1,1543.3,406.58Zm-384.73-4.9a1,1,0,0,1-.83-.43c-1.5-2.16-3-4.39-4.42-6.61a1,1,0,1,1,1.68-1.08c1.42,2.2,2.9,4.41,4.39,6.55a1,1,0,0,1-.82,1.57Zm396.26-12.39a1,1,0,0,1-.52-.15,1,1,0,0,1-.33-1.37l1.71-2.87q1.15-2,2.26-3.94a1,1,0,0,1,1.75,1q-1.12,2-2.29,4c-.57,1-1.14,1.94-1.72,2.9A1,1,0,0,1,1554.83,389.29Zm10-18.22a1,1,0,0,1-.44-.11,1,1,0,0,1-.46-1.34c1.17-2.36,2.3-4.75,3.37-7.13a1,1,0,0,1,1.83.83c-1.09,2.39-2.23,4.81-3.4,7.19A1,1,0,0,1,1564.82,371.07Zm8.37-19a1,1,0,0,1-.37-.07,1,1,0,0,1-.57-1.29c1-2.43,1.87-4.92,2.73-7.4a1,1,0,0,1,1.28-.61,1,1,0,0,1,.61,1.27c-.87,2.5-1.8,5-2.75,7.46A1,1,0,0,1,1573.19,352Zm6.65-19.68a1.45,1.45,0,0,1-.28,0,1,1,0,0,1-.68-1.24c.73-2.53,1.43-5.09,2.07-7.61a1,1,0,0,1,1.21-.73,1,1,0,0,1,.73,1.22c-.65,2.54-1.35,5.13-2.09,7.67A1,1,0,0,1,1579.84,332.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1147.47,384.08a1,1,0,0,1-.87-.5c-.66-1.16-1.32-2.33-2-3.51a1,1,0,0,1,.4-1.35,1,1,0,0,1,1.36.39c.63,1.17,1.28,2.32,1.94,3.48A1,1,0,0,1,1148,384,1,1,0,0,1,1147.47,384.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1124.29,205.8a.75.75,0,0,1-.26,0,1,1,0,0,1-.71-1.22c.34-1.29.7-2.58,1.07-3.87a1,1,0,1,1,1.92.55c-.36,1.28-.72,2.55-1.06,3.83A1,1,0,0,1,1124.29,205.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1129.31,189.42a.91.91,0,0,1-.32-.06,1,1,0,0,1-.62-1.27c.88-2.54,1.82-5.1,2.8-7.63a1,1,0,0,1,1.86.72c-1,2.51-1.9,5-2.77,7.56A1,1,0,0,1,1129.31,189.42Zm7.86-19.72a1,1,0,0,1-.41-.08,1,1,0,0,1-.5-1.33c1.12-2.46,2.28-4.93,3.47-7.34a1,1,0,0,1,1.8.88c-1.18,2.4-2.34,4.85-3.44,7.29A1,1,0,0,1,1137.17,169.7Zm9.6-18.93a1,1,0,0,1-.49-.13,1,1,0,0,1-.38-1.36c.69-1.22,1.39-2.44,2.1-3.65s1.33-2.24,2-3.35a1,1,0,1,1,1.71,1c-.67,1.1-1.33,2.2-2,3.32s-1.4,2.41-2.08,3.62A1,1,0,0,1,1146.77,150.77Zm410.07-3.23a1,1,0,0,1-.87-.5c-1.35-2.31-2.75-4.63-4.17-6.89a1,1,0,1,1,1.69-1.06c1.44,2.28,2.85,4.61,4.21,6.94a1,1,0,0,1-.36,1.37A1,1,0,0,1,1556.84,147.54ZM1158,132.76a1,1,0,0,1-.56-.17,1,1,0,0,1-.26-1.39c1.53-2.22,3.11-4.45,4.71-6.62a1,1,0,1,1,1.61,1.19c-1.59,2.15-3.16,4.36-4.67,6.56A1,1,0,0,1,1158,132.76Zm387.34-3.06a1,1,0,0,1-.81-.42c-1.55-2.18-3.16-4.36-4.78-6.48a1,1,0,0,1,.19-1.41,1,1,0,0,1,1.4.19c1.63,2.14,3.25,4.34,4.82,6.54a1,1,0,0,1-.24,1.39A.94.94,0,0,1,1545.33,129.7Zm-374.55-13.87a1,1,0,0,1-.64-.23,1,1,0,0,1-.13-1.41c1.72-2.08,3.5-4.16,5.28-6.17a1,1,0,0,1,1.5,1.33c-1.77,2-3.53,4.05-5.24,6.11A1,1,0,0,1,1170.78,115.83ZM1532.27,113a1,1,0,0,1-.76-.35c-1.74-2-3.53-4.05-5.34-6a1,1,0,1,1,1.47-1.36c1.82,2,3.64,4,5.39,6.08a1,1,0,0,1-.76,1.65ZM1185,100.1a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42c1.9-1.92,3.87-3.83,5.83-5.67a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42c-2,1.82-3.89,3.72-5.78,5.62A1,1,0,0,1,1185,100.1Zm332.7-2.61a1,1,0,0,1-.69-.28c-1.92-1.87-3.89-3.72-5.87-5.52a1,1,0,0,1,1.34-1.48c2,1.81,4,3.69,5.92,5.57a1,1,0,0,1,0,1.41A1,1,0,0,1,1517.74,97.49ZM1200.67,85.72a1,1,0,0,1-.77-.36A1,1,0,0,1,1200,84c2.06-1.73,4.18-3.46,6.31-5.12a1,1,0,0,1,1.41.17,1,1,0,0,1-.17,1.4c-2.12,1.66-4.22,3.36-6.27,5.08A1,1,0,0,1,1200.67,85.72Zm301.21-2.33a1,1,0,0,1-.63-.23c-2.08-1.68-4.21-3.35-6.34-5a1,1,0,0,1-.2-1.4,1,1,0,0,1,1.41-.2c2.14,1.63,4.29,3.31,6.39,5a1,1,0,0,1-.63,1.78ZM1217.53,72.81A1,1,0,0,1,1217,71c2.22-1.55,4.49-3.07,6.75-4.53a1,1,0,1,1,1.09,1.68c-2.24,1.45-4.5,3-6.7,4.49A1,1,0,0,1,1217.53,72.81Zm267.28-2a1,1,0,0,1-.56-.18c-2.22-1.49-4.49-3-6.76-4.38a1,1,0,0,1,1.06-1.69c2.29,1.42,4.58,2.91,6.82,4.42a1,1,0,0,1,.27,1.38A1,1,0,0,1,1484.81,70.77Zm-249.32-9.29a1,1,0,0,1-.49-1.87c2.33-1.33,4.73-2.65,7.12-3.9a1,1,0,1,1,.93,1.77c-2.37,1.24-4.75,2.54-7.06,3.87A1,1,0,0,1,1235.49,61.48Zm231.2-1.77a.94.94,0,0,1-.48-.13c-2.35-1.29-4.74-2.56-7.12-3.76A1,1,0,1,1,1460,54c2.4,1.22,4.81,2.5,7.17,3.8a1,1,0,0,1,.4,1.36A1,1,0,0,1,1466.69,59.71Zm-212.3-7.9a1,1,0,0,1-.42-1.91c2.46-1.12,5-2.21,7.45-3.25a1,1,0,1,1,.77,1.85c-2.47,1-5,2.11-7.39,3.22A1,1,0,0,1,1254.39,51.81Zm193.28-1.51a1,1,0,0,1-.4-.08c-2.45-1.08-5-2.13-7.43-3.12a1,1,0,0,1-.55-1.3,1,1,0,0,1,1.3-.56c2.49,1,5,2.06,7.48,3.15a1,1,0,0,1-.4,1.91Zm-173.59-6.43a1,1,0,0,1-.34-1.95c2.54-.89,5.14-1.75,7.71-2.56a1,1,0,0,1,.6,1.9c-2.55.81-5.12,1.66-7.64,2.55A1,1,0,0,1,1274.08,43.87Zm153.81-1.23a.91.91,0,0,1-.32-.06c-2.54-.85-5.12-1.67-7.68-2.43a1,1,0,0,1-.67-1.25,1,1,0,0,1,1.25-.67c2.57.77,5.18,1.6,7.74,2.46a1,1,0,0,1-.32,2Zm-133.5-4.92a1,1,0,0,1-.25-2c2.62-.67,5.28-1.3,7.9-1.87a1,1,0,1,1,.43,1.95c-2.61.57-5.24,1.2-7.83,1.86Zm113.1-.94-.23,0c-2.6-.62-5.24-1.21-7.86-1.74a1,1,0,0,1,.39-2c2.65.54,5.31,1.13,7.93,1.75a1,1,0,0,1,.74,1.21A1,1,0,0,1,1407.49,36.78Zm-92.32-3.38a1,1,0,0,1-1-.84,1,1,0,0,1,.83-1.14c2.66-.43,5.36-.82,8-1.16a1,1,0,1,1,.25,2c-2.65.34-5.33.73-8,1.15Zm71.48-.6h-.14c-2.64-.39-5.33-.73-8-1a1,1,0,1,1,.22-2c2.68.3,5.39.64,8,1a1,1,0,0,1-.14,2ZM1336.24,31a1,1,0,0,1-1-.93,1,1,0,0,1,.92-1.07c2.69-.19,5.42-.33,8.11-.43a1,1,0,0,1,1,1,1,1,0,0,1-1,1c-2.67.1-5.37.24-8,.43Zm29.3-.25h-.06c-2.67-.14-5.38-.24-8-.29a1,1,0,0,1-1-1,1,1,0,0,1,1-1h0c2.7,0,5.43.15,8.12.29a1,1,0,0,1,0,2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1564.94,162.67a1,1,0,0,1-.9-.56c-.58-1.19-1.18-2.38-1.78-3.56a1,1,0,0,1,1.78-.91c.61,1.19,1.21,2.39,1.79,3.59a1,1,0,0,1-.45,1.34A1,1,0,0,1,1564.94,162.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1524.51,207a2.85,2.85,0,0,0-2.46-2.2L1487.73,201a150.48,150.48,0,0,0-28.12-39.8l7.88-33.59a2.84,2.84,0,0,0-1.24-3.05l-35-22.09a2.81,2.81,0,0,0-3.28.19L1401,124.29a150,150,0,0,0-48-8.22l-18.19-29.35a2.86,2.86,0,0,0-3-1.28l-40.39,9.15a2.84,2.84,0,0,0-2.19,2.46l-3.77,34.32a150.82,150.82,0,0,0-39.79,28.12L1212,151.61a2.82,2.82,0,0,0-3,1.25l-22.09,35a2.84,2.84,0,0,0,.18,3.29l21.6,26.91a150.43,150.43,0,0,0-8.23,48l-29.35,18.19a2.85,2.85,0,0,0-1.27,3l9.15,40.39a2.84,2.84,0,0,0,2.46,2.19l34.32,3.77a150,150,0,0,0,28.12,39.79l-7.89,33.6a2.84,2.84,0,0,0,1.25,3l35,22.1a2.84,2.84,0,0,0,3.29-.19l26.92-21.59a150.6,150.6,0,0,0,48,8.22L1368.68,448a2.81,2.81,0,0,0,3,1.27l40.4-9.15a2.83,2.83,0,0,0,2.19-2.46l3.76-34.32a150.25,150.25,0,0,0,39.8-28.12l33.59,7.89a2.85,2.85,0,0,0,3-1.25l22.09-35a2.84,2.84,0,0,0-.18-3.29l-21.6-26.92a150.34,150.34,0,0,0,8.23-48l29.34-18.18a2.86,2.86,0,0,0,1.28-3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1351.77,305.16a37.83,37.83,0,1,1,17.07-4.11A37.74,37.74,0,0,1,1351.77,305.16Zm-.07-73.58a35.87,35.87,0,1,0,11.13,1.78h0A35.88,35.88,0,0,0,1351.7,231.58Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1350.73,368.54a100.92,100.92,0,1,1,54-186.28,101.81,101.81,0,0,1,16.87,13.31,1,1,0,0,1,0,1.42,1,1,0,0,1-1.41,0A99.64,99.64,0,0,0,1403.67,184a98.18,98.18,0,0,0-59.26-15.06,99.86,99.86,0,0,0-11.84,1.52l-1.85.37-.14,0-1.54.33A98.92,98.92,0,1,0,1449.82,270a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1v0a100.94,100.94,0,0,1-101.09,98.54Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1075.05,268.52l-19.34-.58a84,84,0,0,0-17.47-21l2.91-19.11a1.59,1.59,0,0,0-.83-1.65l-20.55-10.78a1.58,1.58,0,0,0-1.83.25l-14.07,13.25a84.24,84.24,0,0,0-27.19-2.46l-11.47-15.58a1.58,1.58,0,0,0-1.75-.58l-22.15,6.91a1.59,1.59,0,0,0-1.12,1.47L939.61,238a84.63,84.63,0,0,0-21,17.48l-19.11-2.92a1.61,1.61,0,0,0-1.65.84L887.09,274a1.61,1.61,0,0,0,.25,1.83l13.26,14.07a84.3,84.3,0,0,0-2.46,27.2l-15.59,11.46a1.59,1.59,0,0,0-.57,1.75l6.9,22.15a1.59,1.59,0,0,0,1.47,1.12l19.34.58a84.37,84.37,0,0,0,17.47,21l-2.91,19.11a1.6,1.6,0,0,0,.83,1.65l20.55,10.78a1.59,1.59,0,0,0,1.83-.25l14.07-13.26a84.25,84.25,0,0,0,27.19,2.47l11.46,15.58a1.58,1.58,0,0,0,1.76.57l22.15-6.9a1.59,1.59,0,0,0,1.12-1.47l.58-19.34a84.15,84.15,0,0,0,21-17.47l19.12,2.91a1.56,1.56,0,0,0,1.64-.83l10.79-20.55a1.59,1.59,0,0,0-.25-1.82l-13.26-14.08a84.24,84.24,0,0,0,2.46-27.19l15.58-11.46a1.59,1.59,0,0,0,.58-1.75l-6.9-22.16A1.6,1.6,0,0,0,1075.05,268.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M982.74,332.64a21.61,21.61,0,1,1,5-42.62h0a21.61,21.61,0,0,1-5,42.62Zm-.08-41.23a19.66,19.66,0,1,0,4.62.55h0A19.64,19.64,0,0,0,982.66,291.41Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1106.64,301.31a1,1,0,0,1-1-.91c-.12-1.32-.25-2.64-.41-3.95a1,1,0,0,1,2-.24c.16,1.34.29,2.67.41,4a1,1,0,0,1-.91,1.09Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M984.76,436.45a1,1,0,0,1-1-1,1,1,0,0,1,1-1c2.55-.05,5.14-.17,7.69-.37a1,1,0,0,1,.16,2c-2.59.21-5.22.33-7.82.38ZM972.14,436h-.09c-2.59-.22-5.2-.53-7.78-.92a1,1,0,0,1,.3-2c2.53.38,5.11.69,7.66.91a1,1,0,0,1-.09,2Zm32.9-1.56a1,1,0,0,1-.18-2c2.51-.46,5-1,7.53-1.62a1,1,0,1,1,.48,1.94c-2.52.63-5.1,1.18-7.65,1.65Zm-53-1.84a1,1,0,0,1-.25,0c-2.53-.64-5.07-1.37-7.53-2.16a1,1,0,0,1,.61-1.91c2.43.78,4.92,1.5,7.41,2.13a1,1,0,0,1-.24,2Zm72.67-3.47a1,1,0,0,1-.34-1.94c2.41-.87,4.82-1.82,7.17-2.83a1,1,0,0,1,.79,1.83c-2.38,1-4.83,2-7.28,2.88A1,1,0,0,1,1024.71,429.13Zm-92-3.14a1,1,0,0,1-.4-.08c-2.38-1-4.76-2.17-7.08-3.36a1,1,0,0,1,.92-1.78c2.27,1.17,4.62,2.28,7,3.31a1,1,0,0,1-.4,1.91Zm110.52-5.3a1,1,0,0,1-.49-1.88c2.24-1.24,4.46-2.58,6.61-4a1,1,0,1,1,1.08,1.68c-2.18,1.41-4.44,2.76-6.71,4A1,1,0,0,1,1043.26,420.69Zm-128.47-4.37a1,1,0,0,1-.54-.16c-2.18-1.42-4.34-2.93-6.43-4.48a1,1,0,0,1-.2-1.4,1,1,0,0,1,1.39-.21c2.06,1.53,4.19,3,6.33,4.41a1,1,0,0,1-.55,1.84Zm145.4-7a1,1,0,0,1-.78-.38,1,1,0,0,1,.16-1.41c2-1.59,4-3.27,5.88-5a1,1,0,0,1,1.42.07,1,1,0,0,1-.08,1.41c-1.92,1.74-3.93,3.45-6,5.07A1,1,0,0,1,1060.19,409.34Zm14.87-14a1,1,0,0,1-.67-.26,1,1,0,0,1-.07-1.41c1.72-1.9,3.39-3.88,5-5.88a1,1,0,1,1,1.56,1.24c-1.62,2-3.32,4.05-5.07,6A1,1,0,0,1,1075.06,395.38Zm12.38-16.2a1.06,1.06,0,0,1-.54-.16,1,1,0,0,1-.3-1.38c1.38-2.16,2.71-4.39,4-6.63a1,1,0,1,1,1.74,1c-1.26,2.28-2.61,4.54-4,6.74A1,1,0,0,1,1087.44,379.18Zm9.55-18a1,1,0,0,1-.39-.08,1,1,0,0,1-.53-1.32c1-2.34,2-4.75,2.81-7.17a1,1,0,0,1,1.89.67c-.88,2.46-1.84,4.91-2.86,7.29A1,1,0,0,1,1097,361.15Zm6.47-19.33-.24,0a1,1,0,0,1-.74-1.21l.17-.69c.55-2.26,1-4.57,1.45-6.85a1,1,0,1,1,2,.36c-.43,2.32-.92,4.66-1.47,7l-.17.7A1,1,0,0,1,1103.46,341.82Zm3.26-20.13h-.08a1,1,0,0,1-.92-1.08c.2-2.54.32-5.13.37-7.7a1,1,0,0,1,2,0c0,2.61-.17,5.24-.38,7.83A1,1,0,0,1,1106.72,321.69Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M898.64,403.78a1,1,0,0,1-.67-.26c-1-.91-2-1.83-2.93-2.77a1,1,0,0,1,1.4-1.43q1.41,1.38,2.88,2.73a1,1,0,0,1,.06,1.41A1,1,0,0,1,898.64,403.78Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M858.32,316.25a1,1,0,0,1-1-1c-.05-1.34-.07-2.69-.07-4a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1c0,1.33,0,2.65.06,4a1,1,0,0,1-1,1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M859,298.93h-.1a1,1,0,0,1-.89-1.1c.29-2.72.68-5.48,1.15-8.2a1,1,0,0,1,2,.34c-.46,2.68-.85,5.39-1.13,8.07A1,1,0,0,1,859,298.93Zm4.13-21.13a1,1,0,0,1-.28,0,1,1,0,0,1-.68-1.23c.75-2.66,1.61-5.31,2.53-7.88a1,1,0,1,1,1.88.67c-.91,2.54-1.75,5.15-2.49,7.76A1,1,0,0,1,863.09,277.8Zm7.67-20.11a1,1,0,0,1-.44-.1,1,1,0,0,1-.46-1.34c1.2-2.47,2.49-4.94,3.85-7.32a1,1,0,0,1,1.37-.38,1,1,0,0,1,.37,1.37c-1.34,2.35-2.61,4.77-3.79,7.2A1,1,0,0,1,870.76,257.69Zm11-18.49a1,1,0,0,1-.81-1.59c1.61-2.23,3.32-4.43,5.07-6.54a1,1,0,1,1,1.54,1.27c-1.72,2.08-3.4,4.25-5,6.44A1,1,0,0,1,881.8,239.2Zm14.09-16.29a1,1,0,0,1-.72-.31,1,1,0,0,1,0-1.41c2-1.92,4-3.79,6.12-5.57a1,1,0,1,1,1.3,1.52c-2.06,1.75-4.09,3.6-6,5.48A1,1,0,0,1,895.89,222.91Zm165-7.62a1,1,0,0,1-.63-.22c-2.1-1.71-4.28-3.36-6.49-4.92a1,1,0,1,1,1.15-1.63c2.25,1.58,4.47,3.26,6.6,5a1,1,0,0,1,.15,1.41A1,1,0,0,1,1060.91,215.29Zm-148.34-6a1,1,0,0,1-.57-1.83c2.27-1.55,4.63-3,7-4.44a1,1,0,0,1,1,1.73c-2.33,1.37-4.64,2.84-6.88,4.36A1,1,0,0,1,912.57,209.29Zm130.49-6a.94.94,0,0,1-.48-.13c-2.37-1.31-4.81-2.56-7.26-3.71a1,1,0,0,1,.85-1.81c2.49,1.17,5,2.44,7.37,3.77a1,1,0,0,1,.4,1.36A1,1,0,0,1,1043.06,203.25Zm-111.73-4.52a1,1,0,0,1-.91-.58,1,1,0,0,1,.5-1.33c2.5-1.14,5.07-2.2,7.64-3.17a1,1,0,1,1,.7,1.87c-2.52.95-5,2-7.52,3.12A1,1,0,0,1,931.33,198.73Zm92.06-4.24a1,1,0,0,1-.33-.06c-2.55-.88-5.17-1.69-7.78-2.4a1,1,0,1,1,.53-1.93c2.65.72,5.31,1.55,7.9,2.44a1,1,0,0,1-.32,2Zm-71.77-2.93a1,1,0,0,1-.25-2c2.66-.69,5.38-1.29,8.07-1.8a1,1,0,0,1,1.17.79,1,1,0,0,1-.79,1.17c-2.66.5-5.33,1.1-8,1.78A1.07,1.07,0,0,1,951.62,191.56Zm50.89-2.33h-.16c-2.68-.44-5.39-.79-8.08-1.05a1,1,0,1,1,.19-2c2.73.26,5.49.62,8.21,1.06a1,1,0,0,1-.16,2ZM972.84,188a1,1,0,0,1-1-.92,1,1,0,0,1,.92-1.08c2.74-.21,5.52-.34,8.26-.37h0a1,1,0,0,1,0,2c-2.71,0-5.44.15-8.13.37Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1073.64,227.17a1,1,0,0,1-.73-.32c-.9-1-1.81-1.92-2.75-2.86a1,1,0,0,1,1.42-1.41c1,1,1.88,1.93,2.8,2.91a1,1,0,0,1-.05,1.41A1,1,0,0,1,1073.64,227.17Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M982.17,368.23a57,57,0,1,1,26.55-107.49q2.5,1.32,4.86,2.86l0,0h0l0,0,.06,0h0l0,0h0l0,0,0,0,.09.06,0,0h0l.24.16h0l.15.1h0l.48.32,0,0,0,0h0l0,0,0,0,.35.24,0,0,.35.26.07,0,.05,0h0l.65.48,0,0,.68.51,0,0h0c.54.42,1.07.85,1.59,1.28a1,1,0,0,1,.36.77,1,1,0,0,1-.23.64,1,1,0,0,1-1.41.13,55.5,55.5,0,0,0-9.74-6.51l-.88-.45h0l0,0A54.58,54.58,0,0,0,977,256.45h-.28a55,55,0,1,0,60.53,54.76c0-1,0-2.07-.08-3.1,0,0,0,0,0-.06a1,1,0,0,1,.95-1,1,1,0,0,1,1.05.94c.06,1.08.09,2.15.09,3.22a57.11,57.11,0,0,1-57.07,57Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1769.16,563.62c28-16.57,109.46,46.09,161,0V493.93s-78.8,37.15-116.19,27.43-23.1-30.22,0-34.73,89.56,9.64,108.71-12.18c0,0,15-17.41-10.94-32.16s-26.42-67.12-15.87-87.42c0,0-12.41,5.13-45.94,3.48s-67.14-5.69-71,24.37,6.49,69.9-11.22,75.8-51.64-62.69-7.38-103.65c0,0-53.12-6.68-66.4,3.48s-19.18,42.62,5.91,81,25.08,63.44,11.8,67.87-69.35-117.7-31-148.86c0,0-95.91,27.47-104.77,36.52s11.81,63.81,36.89,91.76,25.09,65.53,16.23,77-17.7-35.75-32.46-53.46S1556.69,401,1556.69,401s-3,13.07-33.93,27.16-73.78,55.4-62,73.11,84.1,90.32,97.38,119.67,17.7,55.74,1.48,46.24-33.94-47.15-54.6-70.38-81.15-76.35-75.25-97c0,0-70.82,57.78-47.21,140.29,0,0,35.41,29.21,78.2,35.2s60.49,10.42,63.44,25.18-26.56,10.33-53.11,5.9-88.53-13.47-98.86-31.08c0,0,42.79,122.11,129.84,107.58,81.64-13.62,88-25.09,88.49-26.46-1.41,5.23-42.64,163.7,140.21,147,0,0-42.79-7.86-50.16-36s-45.74-62.73-26.56-70.54,45.74,94.61,90,98.73,96.3-39.47,95.37-88.5c0,0-37.82,15.28-74.71-10.23s-79.68-69.93-44.27-70.59,118.58,82.85,147.82,76.5,49.35-109.63,49.35-109.63-15,4.43-67.74,0-111.72-20.32-101.39-30.81,48.12,2.59,82.34,13,80.33,4.86,86.79-13,12.49-77,12.49-77-68.58,7.75-99.28,14.28S1741.13,580.2,1769.16,563.62ZM1651.19,730c-39.77-16.27-5.71-28.87,19.12-32.42C1689.16,694.86,1691,746.24,1651.19,730Zm45.68-67.66c-26.56-10.16-28.9-24.7-13.65-28.83C1718.27,624,1723.42,672.47,1696.87,662.31Zm39.83-77c-14.75-4.59-19.18-10.18-5.9-21.64S1751.46,589.84,1736.7,585.26Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M230.92,1224.34c-21.95,21-65.53,71.47-65.53,71.47s50.53,27.45,68.32,32,47.38-29.19,57.72-62.19,20.49-70.32,34.5-72.84-5.48,53.26-30.68,97.76-36.93,54.07-36.93,54.07,93.42,40.27,114.43,20.39-.32-131.83,19.52-159.74,32,30.47,32.22,73.83-32.56,65.23-32.56,65.23c38.63,27.48,101.81,9.7,122.66-27.88s-46.45-114.64-29.76-125.7,23.36,38.41,41.84,59.67,1.42,59.7,1.42,59.7c113-136.87-36-190.36-40.89-192.08,1.35.36,14,1.53,69.37-56.23,59.07-61.58-15.09-162.32-15.09-162.32,8.43,17.85-18.14,72.25-29.09,95.87s-23.5,49.59-33.68,39.19-4-26.95,14.5-64.38,14.53-81.63,14.53-81.63c-53-63.84-137.75-38.8-137.75-38.8,19.71,6.55,29.14,83.82,36.42,113s27.68,63.83,26.42,82-19.91.22-36.1-26.39-34.75-123.93-42.45-143-64-7.45-92.17,9.61-40.18,12.28-40.18,12.28,59.31,69.88,65.4,91.31,39,54.25,25,55.07-44-19.67-52.62-54.94S218.6,907,206.54,909.17s-86.27,63.73-86.27,63.73c45.79-13.65,112.72,97.71,102,105.9s-30.8-5.49-47.76-46.43S128.38,978.43,113,983.5s-39,51.11-39,51.11c56.84-13,93.1,51.49,78.73,62.41s-40.54-19.06-66.64-32.38S44.94,1080.38,28,1108,.14,1142.82.14,1142.82c22,2.64,63.53,31.54,61.14,60.33S81,1229.42,81,1229.42c27.87-3.39,52.82-64.17,69-80.15s40.35-16.22,27.72,18.93S92.47,1246,92.47,1246l55.64,38c64.88-16,59.25-115.16,87.77-128.51S252.87,1203.38,230.92,1224.34Zm165.79-74.74c16.37-17.89,45-38.21,36.31,2.42S384.28,1163.18,396.71,1149.6ZM338.52,1125c11.61-9.93,21.94-.14,15.57,26.61S311.85,1147.8,338.52,1125Zm-81.72-.11c16.39-4.35,18.44,2.23,14.05,16.51S240.41,1129.23,256.8,1124.87Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1897.34,1042.31c22.09-13.36,67.58-47.31,67.58-47.31s-36.92-32.09-50.85-39.17-44.72,15.52-59.37,41-30,54.62-42.06,54.14,14.35-43.23,43.46-75.54,40.62-38.12,40.62-38.12-70.17-50.62-91.28-38-24,109.54-45.6,129.07-20.94-31.18-13.18-67.24,39-48.18,39-48.18c-27-29.93-82.77-26.79-107,.59s17.49,103.75,1.59,109.86-12.33-36.19-23.77-57.25,9.81-49.84,9.81-49.84c-119.07,92.87-5.17,164.7-1.38,167-1.06-.55-11.33-3.84-68,33.93-60.38,40.28-17.33,137.59-17.33,137.59-3.71-16.38,28.36-56.67,41.8-74.27s28.64-36.86,35.18-26.35-1.6,23.12-23.89,50.8-27.08,65.12-27.08,65.12c32.27,62.76,107.26,57.56,107.26,57.56-15.17-9.07-8.78-75-9.46-100.52s-11.25-58.1-6.87-72.93,16.58,3.48,25.13,28.55,6.06,109.32,9,126.58,51.8,18,78.31,9,35.63-2.81,35.63-2.81-36.4-68.94-37.51-87.86-22.38-52.22-10.62-50.33,32.9,24.42,33.59,55.3,19.11,75.34,29.51,75.79,83.38-37,83.38-37c-40.54,2.9-75.64-101.89-65.18-106.71s24.57,10.23,31.11,47.35,28.35,53.27,42,51.89,41.77-35.28,41.77-35.28c-49.59.35-67.84-59.89-53.9-66.31s30.17,23.28,49.39,39.14,37.11-5.49,56.28-25.34,29.51-23.76,29.51-23.76c-17.75-6.24-47-37.88-39.67-61.35s-11.54-25.44-11.54-25.44c-23.77-2.32-55.66,43.57-72,53.86s-36.5,6-19.54-20.82,85.11-48.94,85.11-48.94L1977.09,1008c-56.83,1.35-70.39,84.74-96.53,90.58S1875.26,1055.67,1897.34,1042.31Zm-151.43,31.56c-16.89,11.85-44.41,23.46-29.71-8.68S1758.73,1064.88,1745.91,1073.87Zm43.8,31.16c-11.47,6.11-18.25-3.93-8-25S1816.05,1091,1789.71,1105Zm67.84,15.12c-14.41.6-14.9-5.25-8.63-16.3S1872,1119.55,1857.55,1120.15Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.74,542.09c-25.54-3.72-82.23-6.42-82.23-6.42s8.11,48.24,14.37,62.56,44.38,16.43,71.91,6,57.84-23.15,66.88-15.08-38.55,24.26-81.56,30.7-55.59,3.62-55.59,3.62,22,83.69,46.35,87.34S377,641.52,406.09,640.17s-3.64,37.39-32.55,60.3-60.76,12.39-60.76,12.39c1.85,40.28,46.88,73.28,83,67.53s52.43-91.22,68.59-85.83-13.48,35.78-18,59.31-39.25,32.25-39.25,32.25c151,4,108.65-123.89,107.22-128.11.46,1.1,6.3,10.17,74,17,72.22,7.27,100.81-95.22,100.81-95.22-7.54,15-57.91,25.73-79.47,30.78s-45.54,10.27-43.91-2,15.93-16.85,50.73-24,62.29-33.07,62.29-33.07c15-69-46.24-112.61-46.24-112.61,6,16.64-40.86,63.46-56.57,83.63s-28.23,52-41,60.68-10.59-13.23-1.26-38,64.78-88.26,73.52-103.42S578.61,394.92,552.43,385s-29.3-20.47-29.3-20.47-15.7,76.36-26.87,91.68-15.9,54.54-23.78,45.61-9.89-39.77,9.21-64.05,33.11-70.32,25.37-77.28-87.93-24.37-87.93-24.37c33.15,23.52-6.34,126.74-17.47,123.82s-12.48-23.51,6.06-56.34,11.95-59.14.51-66.77-54.67.69-54.67.69c38.51,31.25,14.33,89.35-.52,85.45s-8.5-37.14-13.26-61.6S307.64,342,280.22,345.17s-37.88-.4-37.88-.4c9.74,16.1,12.18,59.09-8.36,72.59s-7.26,27-7.26,27c16.88,16.89,70.67,1.73,89.87,4.19s32,18.53,1.86,28.5-96.82-16.3-96.82-16.3l3.72,57.2c44.74,35.06,108.2-20.71,132.1-8.6S334.29,545.8,308.74,542.09Zm137,71.85c20.57,1.59,49.19,10.11,17.42,25.59S430.12,612.74,445.73,613.94Zm-14-51.88c12.74,2.56,11.59,14.62-9.66,24.38S402.44,556.16,431.71,562.06Zm-42.78-54.79c11.51,8.69,8.18,13.52-3.69,18.07S377.42,498.57,388.93,507.27Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1793.75,671.58l-148.7-159.41c-17.73-19-42.32-29.24-68.34-29.24H494.77c-80.06,0-146,63.64-146,143.71v593.14c0,80.07,66,146.23,146,146.23H1674.43c80.06,0,143.92-66.16,143.92-146.23V735.44C1818.35,711.74,1809.9,688.92,1793.75,671.58Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1751.73,686.75,1611.8,536.86c-16.67-17.91-39.93-27.53-64.39-27.53H530.35c-75.27,0-136.28,59.91-136.28,135.17v557.59c0,75.26,61,137.21,136.28,137.21H1639.27c75.26,0,135.86-62,135.86-137.21V746.78A87.92,87.92,0,0,0,1751.73,686.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 541.31,
    y: 613.51,
    width: 772.42,
    height: 621.92,
    rx: 88.87
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M808,1236.93a1.5,1.5,0,0,1-1.5-1.5V613.51a1.5,1.5,0,0,1,3,0v621.92A1.5,1.5,0,0,1,808,1236.93Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1049.25,1236.93a1.5,1.5,0,0,1-1.5-1.5V613.51a1.5,1.5,0,0,1,3,0v621.92A1.5,1.5,0,0,1,1049.25,1236.93Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M806.89,779.9H541.31a1.5,1.5,0,0,1,0-3H806.89a1.5,1.5,0,0,1,0,3Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M806.89,926H541.31a1.5,1.5,0,0,1,0-3H806.89a1.5,1.5,0,1,1,0,3Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M806.89,1072.05H541.31a1.5,1.5,0,0,1,0-3H806.89a1.5,1.5,0,1,1,0,3Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1315.94,779.9H1050.35a1.5,1.5,0,0,1,0-3h265.59a1.5,1.5,0,0,1,0,3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1315.94,926H1050.35a1.5,1.5,0,0,1,0-3h265.59a1.5,1.5,0,0,1,0,3Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1315.94,1072.05H1050.35a1.5,1.5,0,0,1,0-3h265.59a1.5,1.5,0,0,1,0,3Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1651.19,
    y: 1016.17,
    width: 53.12,
    height: 247.88,
    rx: 26.56
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M489.93,749.53s-3.95-7.15-3.53-12.9-3.16-14.21.66-13.58,4.6.11,5.64,7S503.05,762.43,489.93,749.53Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M305.7,1406.63c13.9-.39,21.08-2,24.8-3.54,0,1.38,0,2.79,0,4.24a2.74,2.74,0,0,1-2.62,2.79l-76.3-.49c-2.44,0-3.86-2.84-2.8-5.07C258.74,1405.38,284.22,1407.23,305.7,1406.63Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M327.24,1377.38a14,14,0,0,0-13.91-10.21l-6.38.2c-33.91,8.13-51.07,26.88-57.81,36.29a3.55,3.55,0,0,0-.3.58c10,.83,35.48,2.67,57,2.07,13.9-.39,21.09-2,24.8-3.54A95.47,95.47,0,0,0,327.24,1377.38Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M296.24,1345.48l5.33,25.65a4.18,4.18,0,0,0,3.58,3.45,35.67,35.67,0,0,0,8.26-.13,5.28,5.28,0,0,0,4.18-6.19l-3.71-22.78Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.65,1406.63c-13.89-.39-21.08-2-24.8-3.54,0,1.38,0,2.79,0,4.24a2.74,2.74,0,0,0,2.62,2.79l76.3-.49c2.43,0,3.85-2.84,2.8-5.07C453.61,1405.38,428.13,1407.23,406.65,1406.63Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M463.62,1404.56a3.55,3.55,0,0,0-.3-.58c-6.74-9.41-23.9-28.16-57.82-36.29l-16.27-.52s-7.24,12.59-7.38,35.92c3.72,1.52,10.91,3.15,24.8,3.54C428.13,1407.23,453.61,1405.38,463.62,1404.56Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M386.22,1342.52c.18,1.21,2.41,19.64,3.27,26.79a3.56,3.56,0,0,0,3,3.2,37.08,37.08,0,0,0,11.17-.18,4.8,4.8,0,0,0,3.65-4.83v-28.93Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M373.17,1006.17s39.23,149.12,38.53,336.77a7.26,7.26,0,0,1-5.77,7.08c-4.93,1-12.18,2.28-18.19,2.11a6.74,6.74,0,0,1-6.42-5.63c-5.5-32.26-37.08-214-55.07-243.54,0,0-11.83,161.89-8.05,245.88a4,4,0,0,1-3.51,4.14,67.18,67.18,0,0,1-14.6,0,5.33,5.33,0,0,1-4.75-4.52c-3.92-27.31-26.48-189.85-25.52-306.94.06-6.6,17.46-35.31,17.46-35.31Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M250.85,876.48c-10.67-29.19-6.8-64.44-6.76-64.79L247,812c0,.35-3.82,34.92,6.6,63.44Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M524.26,888.69c8.8-47.91-3.83-126.87-3.83-126.87l-17.22,17.84s-2.9,64.45-15.16,91.13C496.12,871.75,511.75,875.35,524.26,888.69Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M488.05,870.79c-2.31,5-4.95,8.73-8,10.38-11.06,6.08-32.53-28.59-48.52-58.63-11.51-21.6-20.2-40.8-20.2-40.8-11.51-13-40-14.78-66.51-13.12A406.51,406.51,0,0,0,290,776.16l-.11,0c-12.71,1.68-23.73,3.08-31.71,4.09a38,38,0,0,0-24,12.89c-24.36,28.18-77.82,105.37-14.9,183.15,8-4.47,19.5-11.63,27.27-19.94-7-19.62-7.53-44.69,7.05-75.46a74.59,74.59,0,0,0,1.86,7.24c20.12,63.69,21.19,116.71,21.13,128.92a4,4,0,0,0,2.54,3.77c26.46,10.61,77.41,4.29,94.5,1.75a5.75,5.75,0,0,0,4.82-6.53c-5.1-36.95,8.82-88.39,23.07-128.68C485.15,970.24,515,939,524.26,888.69,511.75,875.35,496.12,871.75,488.05,870.79Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M293.3,1009.84c-7.26-4.07-35.42-21.56-46.74-53.47-7.77,8.3-19.21,15.46-27.26,19.93,12,14.87,28.29,29.75,49.83,44.32h0c.77,16.58,13.51,22.71,16.42,28.08s-1.22,4.14.62,10.89,21.17-10.73,25.77-14.72,1.84-15,1.84-15a62.63,62.63,0,0,1,1.54-6.9C316.54,1018.34,293.4,1009.88,293.3,1009.84Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M303.82,728.3l-5.1,52.11s29.32,8.83,50.64-6.21l-15-47.36Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M353.52,683.75c.35.9,1.72,64.68,1.72,64.68l-36.56.12-10.32-60.23S347.72,668.68,353.52,683.75Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320.89,695.83a5.25,5.25,0,0,0-1.65,4.32l2.89,31.67a5.18,5.18,0,0,0,.32,1.4c1,2.47,4.7,10.11,12.49,5.86,6.64-3.63,12.79-6.87,17.78-7a5.23,5.23,0,0,1,5.37,5.14,195.69,195.69,0,0,1-1.47,28.8,5.24,5.24,0,0,1-5.52,4.46c-7.18-.44-21.18-1.72-32.41-5.3a5.23,5.23,0,0,1-3.55-4c-1.54-8.36-5.94-31.78-8.2-38.19-2.11-6-10.31-8-14.15-8.66a5.26,5.26,0,0,1-3.54-2.3c-2.42-3.69-5.91-11.65,3.73-17.7a5.24,5.24,0,0,0,1.64-7.12c-2.6-4.33-4.47-11,3.15-16.73s15.19-3.09,19.76-.18a5.45,5.45,0,0,0,6.53-.4,3.51,3.51,0,0,1,3.37-.75,5.12,5.12,0,0,0,6.32-3.61c1.25-4.77,4.63-10.12,13.46-10.62,16.19-.91,21.87,15.89,20.05,26.91s-19.43,11-29,7.85C331.27,687.3,324.16,692.77,320.89,695.83Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M308.12,734.62s2.35-19.34-5.23-22.21-16.81,1.64-11.72,14.09C297.5,742,308.12,734.62,308.12,734.62Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M402.15,885.63H402a.92.92,0,0,1-.8-1c0-.4,5-40.63,2.32-52.22a.93.93,0,0,1,.69-1.11.91.91,0,0,1,1.1.69c2.77,11.91-2.07,51.2-2.28,52.87A.92.92,0,0,1,402.15,885.63Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M518.76,706.82a3.62,3.62,0,0,0-1.42-2.74,3.67,3.67,0,0,0-3-.66l-26.31,6a2,2,0,0,0-1.59,2.24L494.07,780a1.13,1.13,0,0,0,.41.75,1.17,1.17,0,0,0,.83.23l23-2.78a3.64,3.64,0,0,0,3.19-3.76Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M511.36,710.77a2.06,2.06,0,0,0-2.56-1.88l-17.31,4.33a2,2,0,0,0-1.54,2.22l6.56,58.25a1.15,1.15,0,0,0,.44.76,1.11,1.11,0,0,0,.86.21l16-2.85a1.09,1.09,0,0,0,.91-1.15Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M501.41,709.2c0,.21-.24.44-.63.52l-5.79,1.2c-.39.08-.75,0-.79-.22l0-.2c0-.21.24-.44.63-.52l5.79-1.2c.39-.09.75,0,.79.22Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M527.9,724.2c-4.25-1.57-12.57-16-14.16-11.23s.67,11.23,0,13.25-5.28,13.2-3.21,18.35c1.5,3.71,4,15.14,5.22,21.22a4.35,4.35,0,0,0,8.51,0C524.43,765,532.15,725.77,527.9,724.2Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1802.47,1001s51.08,28.3,55.31,76.19.35,246.69-102.09,295.62-238,37.65-289.93,32.3-80.69-40.62-87.11-64.91-16.82-114.76,37.79-143.94,111.94-73.89,169.25-117.43S1741.19,964.2,1802.47,1001Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1432.54,1212.74s13.78.73,15.47,29.1c0,0-32,28.66-75.15,35.48-3.25.51,4.53-22.13,5.7-25.2C1384.12,1237.52,1401.63,1228.12,1432.54,1212.74Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1587.82,1179.39H1574a35.33,35.33,0,0,1-25.4-10.75c-22.92-23.65-80.2-79.32-125.48-94.66a15.3,15.3,0,0,0-18.71,8.09c-9.46,20.17-22.72,67.1,8.69,138.14,3.48,7.87,13.35,11.21,20.5,6.43a11.52,11.52,0,0,0,4.41-5.38l-3.45-83s76.18,66.62,89.42,79.48S1604.49,1222.73,1587.82,1179.39Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1306.52,1386.46c12.2-10.69,31.62-22.67,59.67-26.11l9.48,5.8a103.33,103.33,0,0,1-17.1,18.34c-10.15,5.9-25.83,13.89-38.83,15.62C1307.1,1401.79,1305.24,1394.16,1306.52,1386.46Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1378.56,1252.12c7.51,2.43,10.81,13.07,29.87,6a168.41,168.41,0,0,0,39.2-20.66c.16,1.38.29,2.81.38,4.34,0,0-33.71,32.06-76.89,38.88a4.3,4.3,0,0,1-4.65-5.79A108.55,108.55,0,0,1,1378.56,1252.12Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1297.34,1395.58a100.22,100.22,0,0,1,9.18-9.12c-1.28,7.7.58,15.33,13.22,13.65,13-1.73,28.68-9.72,38.83-15.62-12.72,10.86-32.09,22.38-56.53,21.7A6.41,6.41,0,0,1,1297.34,1395.58Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1577.29,1090.28s-22.38,64.45-66,15.4l-4.15-1.85h0l-31.26-21.36,3.48,12.37a23.11,23.11,0,0,0,13.46,15.12l4.12,1.7c7.84,16.29,24.63,41,50.49,45.65,38.81,7,58.71-45.41,58.71-45.41Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1586.75,1200.44l-136.25,1.48s-77.81,64.37-91.93,162.54c0,0-2.34,7.22,11.73,8.45,0,0,47-30.72,77.71-85.05,37.62-66.6,112.13-36.62,112.13-36.62,24.48-17.65,59.08-21.25,85.14-27.13Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1575.67,1199.24s16.68-45.34,20.27-89.4c0,0-12.21-10.48-19.83-15a5.52,5.52,0,0,1-2.16-7.15c5.61-11.62,39.52-57.23,42.06-57.86,13.81-3.45,70.44-30.37,110.32,24.18,17.11,23.41-3.4,95.48-81,170.11l-16,3.07Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1667,991.33l10.14,33.82a3.73,3.73,0,0,1-1.44,4.14c-4.89,3.34-17.65,10-35.15,3.53a5.53,5.53,0,0,1-3.55-4.73l-2.4-29.46Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1607.61,963.94s5,35.06,18.45,45.84,39.7,2.66,48.56-23.76L1657,940.83Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1659,970.07a1.73,1.73,0,0,1-2.25-1.39c-.49-3.24-1.7-9.64-4.16-14,0,0,1.29-4.6-11.62,2.34s-32.3,17.16-43.71,11.08c-11.13-5.92-22.41-35.75,7-30.22a1.73,1.73,0,0,0,2.06-1.82c-.36-4.9.13-16.17,11.54-19.79,10.69-3.39,16.54,1.43,19,4.34a1.72,1.72,0,0,0,2.7,0c3.2-4.18,11.9-13.07,24.69-7.43,10.54,4.64,12.18,11.13,12,15.18a1.73,1.73,0,0,0,2.46,1.65c3.23-1.49,8.43-2.26,13.4,4,6.88,8.62-3,16.09-5.9,18a1.76,1.76,0,0,0-.79,1.43c0,4.48-.72,24-10.52,35.05a1.75,1.75,0,0,1-2.91-.5l-7.54-18a1.75,1.75,0,0,0-2.14-1Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1658.8,973.72s4.6-18.76,11.6-12.67-1.83,19.49-9.84,22.05Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1595.94,1110.34a.5.5,0,0,1-.5-.5c-.07-20.4,7.78-47.41,7.86-47.68a.5.5,0,1,1,1,.28c-.08.27-7.89,27.14-7.82,47.4a.5.5,0,0,1-.5.5Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1647.64,1127a.45.45,0,0,1-.2,0,.5.5,0,0,1-.26-.66c.14-.31,13.89-31.46,16.34-50.94a.5.5,0,0,1,.56-.43.49.49,0,0,1,.43.55c-2.47,19.63-16.27,50.91-16.41,51.22A.51.51,0,0,1,1647.64,1127Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1686.9,1159.35l-5-4.2a.51.51,0,0,1-.06-.71.52.52,0,0,1,.71-.06l4.33,3.68c25.8-20.1,34.87-59.43,35-59.83a.5.5,0,0,1,.6-.38.51.51,0,0,1,.38.6c-.1.4-9.32,40.41-35.65,60.65Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1460.3,1066l-2.2,3a3.21,3.21,0,0,0,.78,4.53l49.25,33.64a3.19,3.19,0,0,0,4.14-.45h0a3.21,3.21,0,0,0-.37-4.71l-47.05-36.65A3.2,3.2,0,0,0,1460.3,1066Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1496.21,1165.74c-2.42.2-4.32,2.6-4.31,5.51.06,9.59,1.74,29.51,14.45,33.37,15.87,4.82,33.89-2.83,29.63-35.54-.47-3.63-3.14-6.27-6.21-6Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1528.36,1193.58s82.44,0,124.32-65.06l24.6,22.5s-49.24,84.36-142,52.75c0,0-21.41,4.41-33.48,1.07-6.77-1.88-10.45-7.94-12.37-12.89a3.6,3.6,0,0,1,4.56-4.67C1502.58,1190.22,1517.74,1194.68,1528.36,1193.58Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1532.65,1173.4s5-13.49,13.57-3.71-5.35,17.28-13.57,18.36v-3.56s9.59-4.3,8.37-10-8.37,1.43-8.37,1.43Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1501.76,1107.22a23.28,23.28,0,0,1,8.48,4.86,15,15,0,0,1,4.72,8.5,12,12,0,0,1-.15,4.93,11.31,11.31,0,0,1-2.2,4.41c-2.07,2.58-4.83,4.36-7.35,6.31a16.78,16.78,0,0,0-5.93,7.27,8.71,8.71,0,0,0-.47,2.3,7,7,0,0,0,.29,2.32,7.85,7.85,0,0,0,2.7,3.78,20.74,20.74,0,0,0,4.1,2.46c1.45.69,3,1.29,4.35,2.08a14.86,14.86,0,0,1,3.82,3,6.77,6.77,0,0,1,1.84,4.37s0,0,0,0a0,0,0,0,1,0,0,6.68,6.68,0,0,0-1.87-4.3,15,15,0,0,0-3.82-2.87c-2.81-1.5-6-2.42-8.55-4.46a8.16,8.16,0,0,1-2.85-3.91,7.43,7.43,0,0,1-.34-2.44,9,9,0,0,1,.47-2.41,17.19,17.19,0,0,1,6-7.55c2.52-2,5.23-3.8,7.17-6.3a10.47,10.47,0,0,0,2-4.17,11.33,11.33,0,0,0,.08-4.64,14.1,14.1,0,0,0-4.57-8,22.26,22.26,0,0,0-8.19-4.56.5.5,0,1,1,.31-1Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1519.59,1132.57c-1.46,3.11-4.49,4.66-6,7.24a5,5,0,0,0-.77,4.13,6.86,6.86,0,0,0,2.76,3.38c1.24.88,2.67,1.51,4,2.32a9.58,9.58,0,0,1,3.56,3.23,6.16,6.16,0,0,1-2.67,8.41.25.25,0,0,1-.33-.13.25.25,0,0,1,.12-.32,5.61,5.61,0,0,0,2.35-7.65,8.83,8.83,0,0,0-3.37-2.94c-1.34-.77-2.8-1.39-4.13-2.31a7.56,7.56,0,0,1-3.1-3.75,5.81,5.81,0,0,1,.8-4.82c1.7-2.84,4.67-4.47,5.85-7.2a.5.5,0,0,1,.66-.26.5.5,0,0,1,.26.65Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1484.69,1075.13l1.21-2.73h0a.68.68,0,1,1,1.24.55h0l-1.22,2.75a.69.69,0,0,1-.9.35.68.68,0,0,1-.34-.9Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1488.49,1065.94l1-2.81v0a.68.68,0,0,1,.87-.41.69.69,0,0,1,.42.87h0l-1,2.83a.68.68,0,0,1-1.28-.46Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1491.59,1056.49l.78-2.88v0a.69.69,0,0,1,1.34.36h0l-.79,2.91a.69.69,0,0,1-1.34-.36Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1493.88,1046.82l.52-2.94v0a.68.68,0,0,1,.8-.56.7.7,0,0,1,.57.81h0l-.53,3a.69.69,0,0,1-.81.56.69.69,0,0,1-.56-.8Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1495.28,1037l.23-3v0a.71.71,0,1,1,1.41.11h0l-.24,3a.7.7,0,0,1-1.4-.11Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1495.69,1027.07l-.08-3v0a.71.71,0,1,1,1.42,0h0l.08,3a.71.71,0,1,1-1.42,0Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1495,1017.18l-.41-2.95v0a.72.72,0,0,1,1.42-.2h0l.41,3a.71.71,0,0,1-.61.8.72.72,0,0,1-.81-.61Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1493.3,1007.42l-.74-2.88v0a.72.72,0,1,1,1.4-.36h0l.74,2.93a.71.71,0,0,1-.52.87.72.72,0,0,1-.88-.52Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1490.47,997.92l-1-2.78v0a.74.74,0,0,1,.42-.94.74.74,0,0,1,1,.43h0l1.06,2.83a.71.71,0,0,1-.42.93.72.72,0,0,1-.94-.42Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1486.61,988.79l-1.36-2.65v0a.74.74,0,0,1,1.32-.67h0l1.37,2.69a.73.73,0,0,1-.33,1,.72.72,0,0,1-1-.32Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1481.78,980.12l-1.62-2.5h0a.75.75,0,0,1,.22-1,.73.73,0,0,1,1,.22h0l1.64,2.54a.74.74,0,0,1-1.25.8Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1476.1,972l-1.85-2.34h0a.75.75,0,1,1,1.17-.93h0l1.88,2.36a.75.75,0,0,1-.12,1,.74.74,0,0,1-1.05-.12Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1469.68,964.42l-2.06-2.16v0a.76.76,0,0,1,0-1.07.77.77,0,0,1,1.07,0h0l2.08,2.19a.76.76,0,0,1-1.1,1Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1462.62,957.43l-2.23-2v0a.76.76,0,0,1,1-1.14h0l2.25,2a.76.76,0,1,1-1,1.14Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1455,951l-2.37-1.81h0a.78.78,0,0,1-.15-1.08.77.77,0,0,1,1.08-.14h0l2.4,1.83A.77.77,0,0,1,1455,951Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1447,945.18l-2.49-1.64h0a.77.77,0,0,1,.85-1.29h0l2.52,1.66a.78.78,0,0,1,.22,1.07.77.77,0,0,1-1.07.22Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1438.55,939.9l-2.59-1.48h0a.78.78,0,1,1,.78-1.36h0l2.61,1.5a.78.78,0,0,1-.77,1.35Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1429.81,935.14l-2.68-1.33h0a.79.79,0,1,1,.7-1.42h0l2.7,1.34a.77.77,0,0,1,.35,1,.78.78,0,0,1-1,.36Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1420.8,930.89l-2.74-1.17h0a.79.79,0,1,1,.62-1.46h0l2.77,1.19a.8.8,0,1,1-.63,1.46Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1411.58,927.14l-2.8-1h0a.8.8,0,0,1,.55-1.51h0l2.82,1a.8.8,0,1,1-.56,1.5Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1402.18,923.84l-2.85-.89h0a.81.81,0,0,1-.53-1,.82.82,0,0,1,1-.53h0l2.87.91a.81.81,0,0,1-.49,1.54Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1392.63,921l-2.89-.77h0a.82.82,0,0,1,.42-1.58h0l2.91.78a.81.81,0,0,1,.58,1,.82.82,0,0,1-1,.58Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1383,918.6,1380,918h0a.82.82,0,0,1,.36-1.6h0l2.94.64a.82.82,0,1,1-.36,1.6Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1373.2,916.62l-2.94-.51h0a.83.83,0,0,1-.68-1,.83.83,0,0,1,1-.68h0l3,.52a.83.83,0,0,1-.29,1.63Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1363.36,915.05l-3-.4h0a.83.83,0,1,1,.22-1.65h0l3,.4a.83.83,0,0,1,.72.93.84.84,0,0,1-.94.72Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1353.46,913.87l-3-.27h0a.84.84,0,0,1,.15-1.68h0l3,.28a.86.86,0,0,1,.76.92.84.84,0,0,1-.92.75Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1343.53,913.09l-3-.16h0a.86.86,0,0,1-.8-.89.85.85,0,0,1,.89-.8h0l3,.16a.85.85,0,0,1-.09,1.69Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1333.57,912.69l-3-.05h0a.86.86,0,0,1,0-1.71h0l3,.05a.86.86,0,0,1,0,1.71Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1323.6,912.66l-3,.07h0a.86.86,0,0,1-.87-.84.85.85,0,0,1,.84-.88h0l3-.06a.86.86,0,0,1,0,1.71Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1313.64,913l-3,.17h0a.87.87,0,1,1-.1-1.73h0l3-.17a.87.87,0,0,1,.1,1.73Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1303.7,913.72l-3,.28h0a.87.87,0,0,1-.16-1.74h0l3-.29a.87.87,0,0,1,1,.79.87.87,0,0,1-.78,1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1293.78,914.78l-3,.37h0a.88.88,0,0,1-.22-1.74h0l3-.37a.88.88,0,0,1,1,.77.87.87,0,0,1-.76,1Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1283.88,916.07l-3,.43h0a.88.88,0,1,1-.25-1.75h0l3-.42a.88.88,0,1,1,.25,1.74Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1274,917.56l-3,.48h0a.89.89,0,0,1-.28-1.76h0l3-.48a.89.89,0,0,1,.29,1.75Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1264.17,919.24l-2.94.54h0a.89.89,0,1,1-.32-1.76h0l3-.54a.89.89,0,0,1,1,.72.91.91,0,0,1-.72,1Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1254.36,921.1l-2.93.59a.9.9,0,0,1-1.07-.69.91.91,0,0,1,.7-1.07h0l2.94-.59a.9.9,0,1,1,.35,1.76Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1244.59,923.14l-2.92.65a.91.91,0,0,1-.4-1.77h0l2.94-.64a.9.9,0,1,1,.38,1.76Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1234.86,925.36l-2.91.7a.91.91,0,1,1-.44-1.77h0l2.92-.7a.91.91,0,0,1,1.1.67A.92.92,0,0,1,1234.86,925.36Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1225.16,927.74l-2.9.75a.91.91,0,0,1-1.12-.65.93.93,0,0,1,.66-1.12h0l2.91-.75a.91.91,0,1,1,.45,1.77Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1215.51,930.29l-2.89.8a.92.92,0,0,1-.49-1.78h0l2.9-.79a.92.92,0,0,1,1.13.64A.92.92,0,0,1,1215.51,930.29Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1205.9,933l-2.88.84a.93.93,0,1,1-.52-1.78h0l2.89-.84a.93.93,0,0,1,.51,1.78Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1196.33,935.85l-2.86.89a.93.93,0,1,1-.56-1.78h0l2.87-.89a.93.93,0,0,1,.54,1.78Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1186.81,938.85l-2.85.93a.94.94,0,0,1-.59-1.78h0l2.85-.93a.94.94,0,0,1,.58,1.78Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1177.33,942l-2.84,1a.94.94,0,1,1-.61-1.78h0l2.84-1a1,1,0,0,1,1.2.59A.94.94,0,0,1,1177.33,942Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1167.89,945.27l-2.82,1a.95.95,0,1,1-.64-1.78h0l2.83-1a.95.95,0,0,1,.63,1.79Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1158.5,948.66l-2.81,1.05a1,1,0,0,1-.67-1.79h0l2.81-1a1,1,0,0,1,1.23.56A1,1,0,0,1,1158.5,948.66Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1149.16,952.19l-2.8,1.08a1,1,0,0,1-.7-1.79h0l2.8-1.08a1,1,0,1,1,.69,1.79Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1139.85,955.82l-2.78,1.12a1,1,0,0,1-.72-1.79h0l2.79-1.12a1,1,0,0,1,1.25.54A1,1,0,0,1,1139.85,955.82Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1130.6,959.57l-2.77,1.15a1,1,0,0,1-1.27-.53,1,1,0,0,1,.52-1.26h0l2.78-1.14a1,1,0,0,1,.74,1.79Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1121.38,963.42l-2.76,1.18a1,1,0,1,1-.77-1.79h0l2.76-1.17a1,1,0,1,1,.76,1.79Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1112.2,967.37l-2.74,1.21a1,1,0,0,1-.79-1.8h0l2.75-1.2a1,1,0,1,1,.78,1.79Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1103.07,971.42l-2.73,1.23a1,1,0,0,1-.82-1.8h0l2.74-1.23a1,1,0,0,1,.81,1.8Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1094,975.55l-2.72,1.26a1,1,0,0,1-.83-1.8h0l2.73-1.26a1,1,0,1,1,.82,1.8Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1084.92,979.77l-2.71,1.28a1,1,0,0,1-1.33-.47,1,1,0,0,1,.47-1.33h0l2.72-1.28a1,1,0,0,1,1.32.47A1,1,0,0,1,1084.92,979.77Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1075.89,984.06l-2.7,1.31a1,1,0,0,1-.87-1.81h0l2.71-1.3a1,1,0,1,1,.86,1.8Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1066.91,988.43l-2.69,1.33a1,1,0,0,1-.9-1.81h0l2.69-1.32a1,1,0,1,1,.89,1.8Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1058,992.87l-2.68,1.34a1,1,0,0,1-.91-1.81h0l2.68-1.34a1,1,0,1,1,.9,1.81Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1049,997.37l-2.67,1.36a1,1,0,1,1-.93-1.81h0l2.67-1.36a1,1,0,1,1,.92,1.81Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1040.14,1001.93l-2.66,1.38a1,1,0,0,1-1-1.82h0l2.66-1.37a1,1,0,1,1,.94,1.81Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1031.28,1006.55l-2.66,1.39a1,1,0,1,1-1-1.82h0l2.65-1.39a1,1,0,0,1,1.39.43A1,1,0,0,1,1031.28,1006.55Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1022.44,1011.21l-2.65,1.41a1,1,0,1,1-1-1.82h0l2.65-1.41a1,1,0,1,1,1,1.82Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1013.62,1015.92l-2.64,1.43a1,1,0,0,1-1-1.83h0l2.64-1.42a1,1,0,1,1,1,1.82Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1004.83,1020.68l-2.63,1.43a1,1,0,1,1-1-1.83h0l2.64-1.43a1,1,0,1,1,1,1.83Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M996.06,1025.47l-2.63,1.44a1.05,1.05,0,0,1-1.43-.41,1,1,0,0,1,.42-1.42h0l2.63-1.44a1,1,0,0,1,1,1.84Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M987.3,1030.29l-2.62,1.46a1.06,1.06,0,0,1-1-1.85h0l2.62-1.45a1.05,1.05,0,1,1,1,1.84Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M978.56,1035.15l-2.61,1.46a1.07,1.07,0,0,1-1.45-.41,1.06,1.06,0,0,1,.41-1.44h0l2.62-1.46a1.06,1.06,0,0,1,1,1.85Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M969.84,1040l-2.62,1.46a1.06,1.06,0,1,1-1-1.85h0l2.62-1.46a1.06,1.06,0,0,1,1.45.41A1.08,1.08,0,0,1,969.84,1040Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M961.12,1044.92l-2.61,1.48a1.07,1.07,0,0,1-1-1.87h0l2.61-1.47a1.07,1.07,0,0,1,1.46.41A1.06,1.06,0,0,1,961.12,1044.92Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M952.41,1049.84l-2.61,1.48a1.08,1.08,0,0,1-1.06-1.88h0l2.62-1.47a1.07,1.07,0,0,1,1,1.87Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M943.71,1054.77l-2.61,1.47a1.08,1.08,0,1,1-1.06-1.88h0l2.61-1.48a1.08,1.08,0,0,1,1.47.41A1.09,1.09,0,0,1,943.71,1054.77Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M935,1059.69l-2.61,1.48a1.09,1.09,0,1,1-1.07-1.89h0l2.61-1.48a1.09,1.09,0,0,1,1.48.41A1.08,1.08,0,0,1,935,1059.69Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M926.31,1064.62l-2.61,1.48a1.1,1.1,0,0,1-1.49-.42,1.08,1.08,0,0,1,.41-1.48h0l2.61-1.48a1.09,1.09,0,0,1,1.08,1.9Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M917.6,1069.54,915,1071a1.1,1.1,0,1,1-1.08-1.91h0l2.62-1.47a1.1,1.1,0,0,1,1.49.42A1.09,1.09,0,0,1,917.6,1069.54Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M908.89,1074.45l-2.61,1.48a1.11,1.11,0,1,1-1.09-1.93h0l2.61-1.47a1.1,1.1,0,0,1,1.5.43A1.09,1.09,0,0,1,908.89,1074.45Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M900.17,1079.35l-2.62,1.47a1.11,1.11,0,0,1-1.51-.43,1.1,1.1,0,0,1,.43-1.5h0l2.62-1.47a1.11,1.11,0,1,1,1.08,1.93Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M891.44,1084.23l-2.62,1.46a1.11,1.11,0,1,1-1.09-1.94h0l2.62-1.46a1.12,1.12,0,0,1,1.51.43A1.1,1.1,0,0,1,891.44,1084.23Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M882.7,1089.09l-2.63,1.46a1.13,1.13,0,0,1-1.52-.44,1.11,1.11,0,0,1,.44-1.52h0l2.62-1.45a1.12,1.12,0,1,1,1.09,1.95Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M873.94,1093.92l-2.64,1.45a1.12,1.12,0,0,1-1.08-2h0l2.64-1.44a1.12,1.12,0,0,1,1.08,2Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M865.16,1098.72l-2.64,1.44a1.13,1.13,0,0,1-1.08-2h0l2.64-1.43a1.13,1.13,0,0,1,1.08,2Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M856.36,1103.49l-2.64,1.42a1.14,1.14,0,0,1-1.08-2h0l2.65-1.42a1.13,1.13,0,0,1,1.07,2Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M847.54,1108.21l-2.65,1.41a1.14,1.14,0,1,1-1.07-2h0l2.65-1.41a1.14,1.14,0,0,1,1.54.47A1.13,1.13,0,0,1,847.54,1108.21Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M838.7,1112.89l-2.66,1.4a1.15,1.15,0,1,1-1.07-2h0l2.65-1.39a1.14,1.14,0,1,1,1.07,2Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M829.83,1117.52l-2.67,1.38a1.15,1.15,0,1,1-1.06-2h0l2.67-1.38a1.15,1.15,0,0,1,1.06,2Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M820.93,1122.1l-2.68,1.36a1.16,1.16,0,1,1-1-2.06h0l2.68-1.36a1.16,1.16,0,0,1,1,2.06Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M812,1126.62l-2.69,1.34a1.16,1.16,0,1,1-1-2.08h0l2.69-1.34a1.16,1.16,0,0,1,1,2.08Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M803,1131.07l-2.69,1.32a1.17,1.17,0,1,1-1-2.09h0L802,1129a1.17,1.17,0,1,1,1,2.09Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M794,1135.46l-2.7,1.3a1.18,1.18,0,0,1-1-2.12h0l2.7-1.29a1.17,1.17,0,1,1,1,2.11Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M785,1139.77l-2.72,1.28a1.18,1.18,0,0,1-1-2.14h0l2.72-1.27a1.16,1.16,0,0,1,1.56.56A1.18,1.18,0,0,1,785,1139.77Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M775.93,1144l-2.73,1.25a1.17,1.17,0,0,1-1.57-.58,1.19,1.19,0,0,1,.58-1.57h0l2.72-1.25a1.18,1.18,0,0,1,1,2.15Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M766.82,1148.15l-2.74,1.23a1.19,1.19,0,1,1-1-2.17h0l2.74-1.23a1.19,1.19,0,1,1,1,2.17Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M757.67,1152.21l-2.76,1.2a1.19,1.19,0,1,1-.95-2.19h0l2.75-1.2a1.2,1.2,0,0,1,1,2.19Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M748.47,1156.17l-2.76,1.17a1.2,1.2,0,1,1-.94-2.2h0l2.76-1.16a1.19,1.19,0,1,1,.93,2.2Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M739.23,1160l-2.77,1.14a1.21,1.21,0,1,1-.92-2.23h0l2.77-1.14a1.2,1.2,0,0,1,.91,2.23Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M730,1163.8l-2.79,1.11a1.21,1.21,0,0,1-.89-2.25h0l2.79-1.1a1.21,1.21,0,0,1,.89,2.25Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M720.63,1167.45l-2.81,1.07a1.22,1.22,0,1,1-.87-2.27h0l2.8-1.07a1.22,1.22,0,0,1,.87,2.27Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M711.25,1171l-2.82,1a1.22,1.22,0,0,1-.84-2.3h0l2.81-1a1.22,1.22,0,1,1,.84,2.29Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M701.84,1174.39l-2.84,1a1.23,1.23,0,0,1-.81-2.32h0l2.83-1h0a1.23,1.23,0,1,1,.82,2.31Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M692.37,1177.67l-2.85,1a1.23,1.23,0,1,1-.78-2.33h0l2.84-1h0a1.23,1.23,0,1,1,.78,2.33Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M682.86,1180.82l-2.86.92a1.24,1.24,0,1,1-.75-2.36h0l2.85-.91h0a1.23,1.23,0,1,1,.75,2.35Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M673.31,1183.83l-2.88.87a1.24,1.24,0,0,1-.72-2.38h0l2.87-.87h0a1.24,1.24,0,0,1,.72,2.38Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M663.7,1186.69l-2.88.83a1.25,1.25,0,1,1-.69-2.4h0l2.88-.83h0a1.25,1.25,0,0,1,.68,2.4Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M654.06,1189.4l-2.9.78a1.25,1.25,0,0,1-.66-2.42h0l2.89-.77h0a1.25,1.25,0,0,1,.65,2.42Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M644.37,1192l-2.92.73a1.26,1.26,0,0,1-.61-2.44h0l2.9-.73h0a1.26,1.26,0,0,1,.61,2.44Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M634.64,1194.35l-2.93.68a1.26,1.26,0,0,1-.58-2.46h0l2.92-.68h0a1.26,1.26,0,1,1,.58,2.46Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M624.87,1196.57l-2.94.64a1.27,1.27,0,1,1-.54-2.48h0l2.93-.63h0a1.26,1.26,0,1,1,.54,2.47Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M615.06,1198.63l-3,.58a1.27,1.27,0,0,1-1.49-1,1.26,1.26,0,0,1,1-1.49h0l2.94-.57h0a1.27,1.27,0,0,1,.49,2.5Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M605.2,1200.48l-3,.52a1.28,1.28,0,1,1-.44-2.52h0l3-.5h0a1.28,1.28,0,0,1,.44,2.52Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M595.31,1202.12l-3,.46A1.28,1.28,0,1,1,592,1200h0l3-.44h0a1.28,1.28,0,1,1,.38,2.53Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M585.38,1203.55l-3,.39a1.29,1.29,0,0,1-.33-2.56h0l3-.38h0a1.29,1.29,0,1,1,.33,2.55Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M575.43,1204.77l-3,.32a1.29,1.29,0,1,1-.28-2.57h0l3-.32h0a1.29,1.29,0,1,1,.28,2.57Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M565.45,1205.77l-3,.26a1.29,1.29,0,0,1-1.41-1.18,1.3,1.3,0,0,1,1.18-1.41h0l3-.25h0a1.29,1.29,0,1,1,.22,2.58Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M555.46,1206.56l-3,.2a1.31,1.31,0,0,1-.16-2.61h0l3-.19h0a1.3,1.3,0,0,1,.17,2.6Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M545.44,1207.13l-3,.13a1.31,1.31,0,1,1-.11-2.62h0l3-.12h0a1.31,1.31,0,1,1,.11,2.61Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M535.42,1207.49l-3,.06a1.32,1.32,0,0,1,0-2.63h0l3-.06h0a1.3,1.3,0,0,1,1.34,1.29A1.32,1.32,0,0,1,535.42,1207.49Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M525.39,1207.62h-3a1.33,1.33,0,1,1,0-2.65h3a1.32,1.32,0,0,1,1.32,1.32A1.33,1.33,0,0,1,525.39,1207.62Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M515.37,1207.53l-3-.07a1.33,1.33,0,1,1,.06-2.65h0l3,.07h0a1.33,1.33,0,0,1-.06,2.65Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M505.34,1207.22l-3-.14a1.34,1.34,0,0,1,.13-2.67h0l3,.14h0a1.32,1.32,0,0,1,1.27,1.39A1.34,1.34,0,0,1,505.34,1207.22Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M495.32,1206.67l-3-.2a1.34,1.34,0,0,1,.19-2.68h0l3,.21h0a1.33,1.33,0,1,1-.19,2.66Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M485.32,1205.9l-3-.28a1.35,1.35,0,0,1-1.22-1.46,1.36,1.36,0,0,1,1.47-1.22h0l3,.28h0a1.34,1.34,0,0,1-.25,2.67Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M475.34,1204.89l-3-.35a1.35,1.35,0,0,1,.32-2.68h0l3,.35h0a1.35,1.35,0,1,1-.32,2.68Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M465.39,1203.64l-3-.43a1.35,1.35,0,0,1,.38-2.68h0l3,.43h0a1.35,1.35,0,1,1-.38,2.68Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M455.47,1202.14l-3-.49a1.37,1.37,0,0,1-1.12-1.57A1.35,1.35,0,0,1,453,1199h0l3,.49h0A1.36,1.36,0,0,1,457,1201,1.34,1.34,0,0,1,455.47,1202.14Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M445.58,1200.4l-2.95-.57a1.36,1.36,0,0,1,.52-2.68h0l2.93.57h0a1.36,1.36,0,1,1-.52,2.67Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M435.75,1198.41l-2.94-.65a1.37,1.37,0,1,1,.59-2.67h0l2.92.65h0a1.37,1.37,0,1,1-.59,2.67Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M426,1196.16l-2.92-.72a1.39,1.39,0,0,1-1-1.67,1.37,1.37,0,0,1,1.67-1h0l2.9.72h0a1.37,1.37,0,0,1-.66,2.66Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M416.25,1193.65l-2.9-.8a1.38,1.38,0,1,1,.74-2.66h0l2.88.8h0a1.39,1.39,0,0,1,1,1.7A1.38,1.38,0,0,1,416.25,1193.65Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M406.6,1190.88l-2.88-.89a1.39,1.39,0,0,1,.82-2.65h0l2.86.88h0a1.39,1.39,0,0,1-.82,2.65Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M397,1187.83l-2.86-1a1.39,1.39,0,0,1,.9-2.64h0l2.83,1h0a1.39,1.39,0,0,1-.89,2.63Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M387.56,1184.51l-2.82-1a1.39,1.39,0,0,1-.83-1.79,1.4,1.4,0,0,1,1.8-.82h0l2.8,1.05h0a1.39,1.39,0,1,1-1,2.61Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M378.18,1180.92l-2.79-1.14a1.4,1.4,0,0,1,1.06-2.6h0l2.77,1.13h0a1.4,1.4,0,0,1-1.06,2.6Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M368.92,1177l-2.75-1.22a1.41,1.41,0,1,1,1.14-2.58h0l2.73,1.21h0a1.4,1.4,0,0,1,.72,1.85A1.42,1.42,0,0,1,368.92,1177Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M359.78,1172.87l-2.71-1.31a1.41,1.41,0,1,1,1.22-2.54h0l2.69,1.3h0a1.41,1.41,0,1,1-1.23,2.54Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M350.78,1168.41l-2.67-1.39a1.42,1.42,0,1,1,1.31-2.51h0l2.65,1.39h0a1.42,1.42,0,0,1,.6,1.91A1.4,1.4,0,0,1,350.78,1168.41Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M341.93,1163.67l-2.63-1.48a1.42,1.42,0,0,1,1.4-2.48h0l2.6,1.47h0a1.42,1.42,0,0,1-1.39,2.48Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M333.23,1158.63l-2.57-1.57a1.43,1.43,0,1,1,1.49-2.44h0l2.55,1.55h0a1.43,1.43,0,0,1-1.49,2.44Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M324.72,1153.29l-2.52-1.66a1.43,1.43,0,1,1,1.58-2.39h0l2.49,1.64h0a1.43,1.43,0,1,1-1.57,2.39Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M316.39,1147.66l-2.46-1.74a1.44,1.44,0,0,1,1.67-2.35h0l2.44,1.73h0a1.44,1.44,0,1,1-1.67,2.34Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M308.27,1141.74l-2.39-1.83a1.45,1.45,0,0,1,1.75-2.3h0l2.36,1.82h0a1.44,1.44,0,0,1-1.76,2.29Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M300.37,1135.53l-2.33-1.92a1.45,1.45,0,0,1,1.85-2.24h0l2.3,1.9h0a1.45,1.45,0,1,1-1.84,2.23Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M292.7,1129l-2.26-2a1.46,1.46,0,0,1,1.94-2.18h0l2.23,2h0a1.45,1.45,0,1,1-1.93,2.17Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M285.27,1122.26l-2.18-2.09a1.46,1.46,0,1,1,2-2.11h0l2.15,2.07h0a1.46,1.46,0,0,1-2,2.11Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M278.1,1115.2,276,1113a1.46,1.46,0,1,1,2.1-2h0l2.07,2.15h0a1.46,1.46,0,1,1-2.11,2Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M271.21,1107.89l-2-2.25a1.48,1.48,0,0,1,2.2-2h0v0l2,2.22h0a1.47,1.47,0,0,1-2.19,2Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M264.59,1100.31l-1.92-2.32a1.47,1.47,0,0,1,.19-2.08,1.48,1.48,0,0,1,2.08.19h0v0l1.9,2.29,0,0a1.48,1.48,0,0,1-2.28,1.88Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M258.27,1092.5l-1.84-2.39a1.48,1.48,0,1,1,2.34-1.81h0l1.82,2.37h0a1.48,1.48,0,1,1-2.34,1.81Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M252.23,1084.46l-1.75-2.45a1.49,1.49,0,1,1,2.42-1.73h0l1.73,2.43h0a1.49,1.49,0,1,1-2.42,1.73Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M246.49,1076.21l-1.67-2.51a1.49,1.49,0,1,1,2.49-1.65h0l1.64,2.49h0a1.49,1.49,0,1,1-2.48,1.65Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M241,1067.77l-1.58-2.57a1.5,1.5,0,0,1,2.56-1.57h0v0l1.56,2.54h0a1.48,1.48,0,0,1-.49,2.06A1.5,1.5,0,0,1,241,1067.77Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M235.87,1059.15l-1.49-2.62A1.5,1.5,0,1,1,237,1055h0l1.48,2.6h0a1.5,1.5,0,0,1-2.61,1.49Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M231,1050.36l-1.4-2.67a1.51,1.51,0,1,1,2.67-1.41h0l1.39,2.64h0a1.51,1.51,0,0,1-2.67,1.41Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M226.42,1041.42l-1.32-2.71a1.51,1.51,0,1,1,2.72-1.33h0l1.3,2.69h0a1.51,1.51,0,1,1-2.72,1.33Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M222.12,1032.34l-1.24-2.75a1.52,1.52,0,0,1,2.78-1.25h0v0l1.22,2.72h0a1.52,1.52,0,0,1-2.77,1.25Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M218.1,1023.13l-1.15-2.79a1.52,1.52,0,0,1,2.82-1.16h0l1.13,2.76v0a1.52,1.52,0,1,1-2.82,1.16Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M214.36,1013.81l-1.07-2.82a1.53,1.53,0,0,1,2.86-1.09h0l1.05,2.79h0a1.53,1.53,0,1,1-2.86,1.09Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M210.89,1004.38l-1-2.84a1.54,1.54,0,1,1,2.9-1h0l1,2.83h0a1.53,1.53,0,0,1-2.9,1Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M207.69,994.87l-.91-2.88a1.54,1.54,0,1,1,2.93-.93h0v0l.9,2.85h0a1.54,1.54,0,0,1-2.93.93Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M204.74,985.27l-.83-2.9a1.55,1.55,0,0,1,3-.85h0l.82,2.87h0a1.55,1.55,0,0,1-3,.86Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M202.06,975.59l-.76-2.91a1.55,1.55,0,1,1,3-.78h0l.75,2.89h0a1.55,1.55,0,0,1-3,.78Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M199.63,965.85l-.69-2.93a1.56,1.56,0,0,1,3-.71h0l.67,2.92h0a1.55,1.55,0,0,1-3,.7Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M197.44,956.05l-.61-2.95a1.56,1.56,0,0,1,3.06-.63h0l.6,2.93h0a1.56,1.56,0,1,1-3.06.63Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M195.49,946.21l-.53-3a1.57,1.57,0,0,1,3.08-.56h0v0l.53,2.94h0a1.57,1.57,0,0,1-3.09.56Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M193.79,936.31l-.47-3a1.57,1.57,0,0,1,3.11-.49h0l.46,3h0a1.57,1.57,0,1,1-3.1.48Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M192.31,926.39l-.39-3a1.58,1.58,0,1,1,3.13-.41h0l.39,3h0a1.58,1.58,0,0,1-3.13.42Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M191.07,916.43l-.33-3a1.58,1.58,0,1,1,3.15-.35h0l.32,3h0a1.58,1.58,0,1,1-3.14.35Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M190.05,906.44l-.26-3a1.59,1.59,0,1,1,3.16-.28h0l.26,3h0a1.59,1.59,0,1,1-3.16.27Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M189.25,896.44l-.19-3a1.59,1.59,0,1,1,3.18-.21h0l.19,3v0a1.59,1.59,0,1,1-3.18.2Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M188.67,886.42l-.13-3a1.6,1.6,0,1,1,3.2-.14h0l.13,3h0a1.6,1.6,0,0,1-3.2.13Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M188.31,876.4l-.07-3a1.61,1.61,0,1,1,3.21-.08h0l.07,3h0a1.61,1.61,0,0,1-3.21.07Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M188.16,866.36v-3a1.61,1.61,0,0,1,3.22,0h0v3h0a1.61,1.61,0,1,1-3.22,0Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M188.21,856.33l0-3a1.62,1.62,0,0,1,3.24.06h0l-.06,3h0a1.62,1.62,0,0,1-3.23-.06Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M188.46,846.3l.12-3a1.62,1.62,0,0,1,3.24.13h0l-.12,3h0a1.62,1.62,0,0,1-3.24-.13Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M188.92,836.28l.17-3a1.63,1.63,0,0,1,3.25.19h0l-.18,3h0a1.62,1.62,0,1,1-3.24-.19Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M189.57,826.27l.24-3a1.63,1.63,0,1,1,3.25.25h0l-.23,3h0a1.63,1.63,0,0,1-3.25-.26Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M190.43,816.27l.29-3a1.64,1.64,0,0,1,3.26.32h0l-.29,3h0a1.63,1.63,0,1,1-3.25-.33Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M191.48,806.3l.36-3a1.64,1.64,0,1,1,3.26.39h0l-.36,3h0a1.64,1.64,0,0,1-3.26-.39Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M192.73,796.34l.41-3a1.65,1.65,0,0,1,3.27.46h0l-.42,3h0a1.65,1.65,0,0,1-3.26-.46Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M194.18,786.42l.47-3a1.65,1.65,0,0,1,3.26.52h0l-.47,3h0a1.65,1.65,0,1,1-3.26-.52Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M195.81,776.52l.53-3a1.66,1.66,0,0,1,3.27.58h0l-.53,3h0a1.66,1.66,0,0,1-3.27-.58Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M197.64,766.66l.59-2.95a1.67,1.67,0,0,1,3.27.64h0l-.58,2.93h0a1.67,1.67,0,0,1-3.27-.65Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M199.67,756.83l.64-2.94a1.67,1.67,0,1,1,3.26.72h0l-.64,2.92h0a1.67,1.67,0,0,1-3.26-.72Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M201.88,747.05l.7-2.93a1.68,1.68,0,1,1,3.26.78h0l-.7,2.91h0a1.67,1.67,0,0,1-3.25-.78Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M204.28,737.3l.76-2.91a1.68,1.68,0,1,1,3.25.85h0l-.76,2.89h0a1.68,1.68,0,1,1-3.25-.85Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M206.87,727.61l.81-2.9a1.69,1.69,0,0,1,3.25.91h0l-.81,2.87h0a1.68,1.68,0,1,1-3.24-.91Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M209.65,718l.87-2.88a1.69,1.69,0,0,1,3.23,1h0l-.87,2.86h0a1.69,1.69,0,1,1-3.23-1Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M212.61,708.38l.92-2.86a1.7,1.7,0,0,1,3.23,1h0l-.92,2.85h0a1.69,1.69,0,1,1-3.22-1Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M215.75,698.86l1-2.85a1.7,1.7,0,1,1,3.22,1.11h0L219,700h0a1.7,1.7,0,0,1-3.22-1.1Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M219.08,689.39l1-2.83a1.71,1.71,0,0,1,3.21,1.18h0l-1,2.81h0a1.7,1.7,0,1,1-3.2-1.17Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M222.59,680l1.09-2.81a1.71,1.71,0,0,1,3.19,1.24h0l-1.09,2.79h0a1.71,1.71,0,0,1-3.19-1.24Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M226.28,670.66l1.14-2.79a1.72,1.72,0,0,1,3.18,1.31h0L229.46,672h0a1.71,1.71,0,1,1-3.17-1.3Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M230.15,661.4l1.19-2.76A1.72,1.72,0,1,1,234.5,660h0l-1.19,2.74h0a1.72,1.72,0,0,1-3.16-1.37Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M234.19,652.22l1.25-2.74a1.73,1.73,0,0,1,3.15,1.43h0l-1.24,2.73h0a1.73,1.73,0,1,1-3.14-1.43Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M238.41,643.12l1.31-2.72a1.73,1.73,0,1,1,3.12,1.5h0l-1.3,2.7h0a1.74,1.74,0,0,1-3.13-1.5Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M242.81,634.1l1.36-2.69a1.74,1.74,0,0,1,3.1,1.56h0l-1.35,2.67h0a1.74,1.74,0,0,1-3.11-1.56Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M247.39,625.17l1.4-2.67a1.75,1.75,0,0,1,3.09,1.63h0l-1.4,2.65h0a1.75,1.75,0,0,1-2.36.72A1.73,1.73,0,0,1,247.39,625.17Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M252.13,616.32l1.46-2.63a1.75,1.75,0,0,1,3.06,1.69h0L255.19,618h0a1.75,1.75,0,0,1-3.06-1.7Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M257.05,607.58l1.51-2.61a1.75,1.75,0,1,1,3,1.76h0l-1.5,2.59h0a1.75,1.75,0,0,1-3-1.76Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M262.13,598.93l1.56-2.58a1.76,1.76,0,1,1,3,1.83h0l-1.55,2.55h0a1.76,1.76,0,0,1-3-1.82Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M267.39,590.38l1.61-2.54a1.76,1.76,0,1,1,3,1.89h0l-1.6,2.52h0a1.76,1.76,0,0,1-3-1.89Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M272.81,581.94l1.66-2.51a1.77,1.77,0,0,1,3,2h0l-1.65,2.49h0a1.77,1.77,0,0,1-3-1.95Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M278.4,573.61l1.71-2.48a1.78,1.78,0,1,1,2.93,2h0l-1.7,2.45h0a1.77,1.77,0,0,1-2.92-2Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M284.16,565.39l1.76-2.45a1.78,1.78,0,0,1,2.89,2.08h0l-1.75,2.42h0a1.78,1.78,0,0,1-2.89-2.08Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M290.08,557.28l1.81-2.4a1.78,1.78,0,1,1,2.85,2.14h0l-1.8,2.39h0a1.79,1.79,0,1,1-2.85-2.15Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M296.16,549.3l1.85-2.37a1.8,1.8,0,1,1,2.83,2.21h0L299,551.5h0a1.79,1.79,0,0,1-2.82-2.21Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M302.4,541.44l1.9-2.33a1.8,1.8,0,1,1,2.79,2.27h0l-1.89,2.32h0a1.8,1.8,0,0,1-2.78-2.28Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M308.8,533.71l1.95-2.29a1.81,1.81,0,1,1,2.75,2.34h0L311.55,536h0a1.81,1.81,0,0,1-2.75-2.34Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M315.36,526.11l2-2.25a1.81,1.81,0,0,1,2.7,2.4h0l-2,2.23h0a1.81,1.81,0,1,1-2.7-2.4Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M322.07,518.65l2-2.21a1.82,1.82,0,0,1,2.67,2.46h0l-2,2.19h0a1.81,1.81,0,0,1-2.66-2.46Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M328.93,511.33l2.09-2.18a1.82,1.82,0,1,1,2.62,2.53h0l-2.07,2.15h0a1.82,1.82,0,0,1-2.62-2.52Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M335.94,504.14l2.13-2.13a1.82,1.82,0,1,1,2.58,2.58h0l-2.12,2.11h0a1.82,1.82,0,0,1-2.57-2.58Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M343.09,497.1l2.17-2.09a1.83,1.83,0,1,1,2.53,2.64h0l-2.15,2.07h0a1.83,1.83,0,1,1-2.53-2.64Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M350.38,490.2l2.21-2a1.83,1.83,0,1,1,2.49,2.69h0l-2.2,2h0a1.83,1.83,0,1,1-2.48-2.69Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M357.8,483.44l2.25-2a1.84,1.84,0,1,1,2.44,2.75h0l-2.23,2h0a1.84,1.84,0,1,1-2.44-2.76Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M365.35,476.84l2.29-2a1.85,1.85,0,1,1,2.4,2.82h0l-2.28,1.94h0a1.84,1.84,0,1,1-2.39-2.81Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M373,470.38l2.33-1.91a1.85,1.85,0,0,1,2.34,2.87h0l-2.31,1.89h0a1.85,1.85,0,0,1-2.34-2.86Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M380.84,464.08l2.37-1.86a1.85,1.85,0,1,1,2.3,2.91h0L383.14,467h0a1.85,1.85,0,1,1-2.3-2.91Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M388.77,457.93l2.41-1.82a1.86,1.86,0,0,1,2.24,3h0l-2.39,1.8h0a1.86,1.86,0,0,1-2.24-3Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M396.82,451.93l2.44-1.77a1.87,1.87,0,1,1,2.19,3h0L399,455h0a1.87,1.87,0,0,1-2.19-3Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M405,446.09l2.47-1.72a1.87,1.87,0,0,1,2.15,3.07h0l-2.45,1.71h0a1.87,1.87,0,0,1-2.14-3.07Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M413.26,440.41l2.5-1.67a1.88,1.88,0,1,1,2.09,3.12h0l-2.49,1.66h0a1.87,1.87,0,0,1-2.08-3.12Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M421.64,434.89l2.54-1.62a1.88,1.88,0,0,1,2,3.17h0l-2.52,1.61h0a1.88,1.88,0,0,1-2-3.17Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M430.13,429.54,432.7,428a1.89,1.89,0,0,1,2,3.22h0l-2.55,1.56h0a1.88,1.88,0,0,1-2-3.21Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M438.72,424.34l2.6-1.52a1.89,1.89,0,1,1,1.92,3.26h0l-2.58,1.51h0a1.9,1.9,0,0,1-1.92-3.27Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M447.41,419.32l2.62-1.48a1.9,1.9,0,1,1,1.86,3.31h0l-2.61,1.46h0a1.9,1.9,0,1,1-1.86-3.31Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M456.19,414.46l2.65-1.43a1.91,1.91,0,0,1,1.81,3.36h0L458,417.81h0a1.9,1.9,0,1,1-1.8-3.35Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M465.07,409.77l2.68-1.37a1.91,1.91,0,0,1,1.74,3.4h0l-2.67,1.36h0a1.91,1.91,0,0,1-1.73-3.4Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M474,405.25l2.71-1.32a1.91,1.91,0,0,1,1.68,3.44h0l-2.68,1.31h0a1.91,1.91,0,1,1-1.68-3.44Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M483.08,400.91l2.73-1.27a1.92,1.92,0,0,1,1.62,3.48h0l-2.72,1.26h0a1.92,1.92,0,0,1-1.61-3.48Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M492.21,396.74l2.75-1.22a1.93,1.93,0,0,1,1.56,3.53h0l-2.74,1.21h0a1.92,1.92,0,1,1-1.55-3.52Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M501.42,392.75l2.78-1.16a1.93,1.93,0,1,1,1.49,3.56h0l-2.76,1.15h0a1.93,1.93,0,1,1-1.49-3.56Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M510.71,388.94l2.8-1.11a1.93,1.93,0,0,1,1.42,3.6h0l-2.78,1.1h0a1.93,1.93,0,0,1-1.42-3.6Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M520.06,385.3l2.83-1.05a1.94,1.94,0,0,1,1.35,3.64h0l-2.8,1.05h0a1.94,1.94,0,0,1-1.36-3.64Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M529.49,381.85l2.84-1a1.95,1.95,0,1,1,1.29,3.67h0l-2.82,1h0a1.95,1.95,0,0,1-1.29-3.68Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M539,378.59l2.86-.94a2,2,0,0,1,1.23,3.71h0l-2.84.93h0a2,2,0,0,1-1.22-3.71Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M548.54,375.51l2.88-.88a2,2,0,0,1,1.15,3.74h0l-2.86.88h0a2,2,0,1,1-1.15-3.74Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M558.15,372.62l2.89-.83a2,2,0,0,1,1.09,3.78h0l-2.87.82h0a2,2,0,1,1-1.08-3.78Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M567.82,369.92l2.91-.77a2,2,0,0,1,1,3.81h0l-2.89.76h0a2,2,0,0,1-1-3.81Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M577.54,367.41l2.92-.71a2,2,0,1,1,.94,3.84h0l-2.91.71h0a2,2,0,0,1-.93-3.84Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M587.31,365.1l2.94-.65a2,2,0,1,1,.86,3.86h0l-2.92.65h0a2,2,0,0,1-.86-3.86Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M597.12,363l3-.59a2,2,0,0,1,.79,3.89h0l-2.93.59h0a2,2,0,0,1-.78-3.89Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M607,361.06l3-.53a2,2,0,1,1,.71,3.91h0l-2.94.53h0a2,2,0,0,1-.71-3.92Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M616.86,359.34l3-.47a2,2,0,0,1,.63,3.94h0l-3,.47h0a2,2,0,0,1-.63-3.94Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M626.79,357.83l1-.14a2,2,0,1,1,.56,4h0l-.95.13a2,2,0,1,1-.56-3.95Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "637.61 333.88 641.14 365.46 661.01 349.49 637.61 333.88"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M777.57,299.85,700.68,384.2a8,8,0,0,1-11.58.32l-81.79-80.4a3.22,3.22,0,0,1,2.28-5.52Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "637.62 333.88 777.57 299.85 650.77 346.9 651.38 355.7 637.62 333.88"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "658.63 354.56 641.14 365.46 650.77 346.9 658.63 354.56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationCard1);
export default __webpack_public_path__ + "static/media/migration_card_1.c0340aed6cb4a67770c846be8335428f.svg";
export { ForwardRef as ReactComponent };